const TRANSLATION_DE = {
    "No alerts for this period": "Keine Warnmeldungen für diesen Zeitraum",
    "Unable to load alerts for this class": "Warnmeldungen für diese Klasse konnten nicht geladen werden",

    "Select which classes to include in the year analytics view.": "Wähle die Klassen aus, die in der Jahrgangsanalyse berücksichtigt werden sollen.",
    "See less classes": "Weniger Klassen anzeigen",
    "See all classes": "Alle Klassen anzeigen",

    // Filtered analytics student summary
    "studentCountLabel_one": "{{total}} Schüler",
    "studentCountLabel_other": "{{total}} Schüler",
    "Students included": "Einbezogene Schüler",
    "checked in during this period": "haben in diesem Zeitraum eingecheckt",
    "Students who checked in": "Schüler mit Check-in",
    "{{percentage}}% of included students · {{count}} haven't checked in": "{{percentage}}% der einbezogenen Schüler · {{count}} haben nicht eingecheckt",
    "All accessible students": "Alle zugänglichen Schüler",
    "Selected student groups": "Ausgewählte Schülergruppen",
    "Unable to load student count": "Schülerzahl konnte nicht geladen werden",
    "Based on {{checkIns}} check-ins from {{checkedIn}} of {{included}} included students": "Basierend auf {{checkIns}} Check-ins von {{checkedIn}} der {{included}} einbezogenen Schüler",

    // Year-group analytics
    "Year analytics": "Jahrgangsanalyse",
    "Search for years": "Nach Jahrgängen suchen",
    "We found {{total}} year(s)": "{{total}} Jahrgang/Jahrgänge gefunden",
    "Year {{year}} analytics": "Analyse für Jahrgang {{year}}",
    "Change year": "Jahrgang wechseln",
    "Year emotional breakdown": "Emotionsverteilung im Jahrgang",
    "Year total": "Gesamtzahl im Jahrgang",
    "Wellbeing comparison for selected classes": "Wohlbefinden der ausgewählten Klassen vergleichen",
    "Alerts for selected classes": "Warnmeldungen für ausgewählte Klassen",
    "Compared with year average": "Im Vergleich zum Jahrgangsdurchschnitt",
    "percentage points": "Prozentpunkte",
    "No matching years": "Keine passenden Jahrgänge",
    "No year groups assigned": "Keine Jahrgänge zugewiesen",
    "Select at least one class to view analytics": "Wählen Sie mindestens eine Klasse aus, um die Analyse anzuzeigen",
    "You do not have access to this year": "Sie haben keinen Zugriff auf diesen Jahrgang",
    "You do not have access to year analytics": "Sie haben keinen Zugriff auf die Jahrgangsanalyse",
    "Those classes are outside the selected year": "Diese Klassen gehören nicht zum ausgewählten Jahrgang",
    "Unable to load year analytics": "Jahrgangsanalyse konnte nicht geladen werden",
    "Unable to load analytics search": "Analysesuche konnte nicht geladen werden",
    "Check-ins overview for selected classes": "Übersicht der Check-ins für ausgewählte Klassen",
    "Emotional trends for selected classes": "Emotionale Entwicklung der ausgewählten Klassen",
    "Unresolved alerts for this year during the selected period.": "Offene Warnmeldungen für diesen Jahrgang im ausgewählten Zeitraum.",
    "Compare classes against the full year. The year average stays fixed when classes are filtered.": "Vergleichen Sie Klassen mit dem gesamten Jahrgang. Der Jahrgangsdurchschnitt bleibt beim Filtern der Klassen unverändert.",
    "Assigned groups": "Zugewiesene Gruppen",
    "Assigned groups average": "Durchschnitt der zugewiesenen Gruppen",
    "Assigned groups emotional breakdown based on {{number}} check-ins": "Emotionsverteilung der zugewiesenen Gruppen basierend auf {{number}} Check-ins",
    "Use this search to explore student, class, year, or counsellor analytics and access deeper insights.": "Nutzen Sie die Suche für Analysen von Schülern, Klassen, Jahrgängen und Beratung, um tiefere Einblicke zu erhalten.",

    confirmDeletion: 'Löschen bestätigen',
    deleteTheTemplateFor: 'Vorlage löschen ',
    cancel: 'Abbrechen',
    delete: 'Löschen',
    createContent: 'Inhalte erstellen',
    askAQuestion: 'Frage stellen',
    createAPoll: 'Abstimmung starten',
    createAPost: 'Post erstellen',
    orChooseFromTemplatesBelow: 'oder eine der Vorlagen (s.u.) auswählen',
    on: 'An',
    off: 'Aus',
    Off: 'Aus',
    never: 'Nie',
    chooseTemplate: 'Vorlage wählen ',
    thereAreNoTemplatesCreated: 'Keine Vorlagen erstellt',
    howAreYouToday: 'Wie geht es Dir heute? ',
    selectEmotion: 'Wähle einen Emoji',
    question: 'Frage',
    genderSelection: 'Geschlecht',
    all: 'Alle',
    male: 'Männlich',
    Male: 'Männlich',
    female: 'Weiblich',
    Female: 'Weiblich',
    settings: 'Einstellungen',
    support: 'Hilfe',
    privacyPolicy: 'Datenschutzbestimmungen',
    about: 'Über',
    dayReview: 'Mein Tag',
    dailyReflection: 'Wie war mein Tag',
    youLiked: 'Gefällt dir',
    like: 'Gefällt mir',
    edit: 'Bearbeiten',
    answered: 'Beantwortet',
    showLess: 'Weniger anzeigen',
    showMore: 'Mehr anzeigen',
    search: 'Suchen',
    targetGroup: 'Zielgruppe',
    quickAction: 'Abkürzung',
    select: 'Auswahl',
    selectByGroup: 'Nach Gruppe auswählen',
    selectSchoolYearsThatYouLikeToTarget: 'Jahrgänge wählen',
    years: 'Jahren',
    Years: 'Jahrgänge',
    year: 'Jahr',
    Year: 'Jahrgang',
    selectClassesThatYouLikeToTarget: 'Gewünschte Klassen wählen',
    classes: 'Klassen',
    class: 'Klasse',
    selectACustomListThatYouLikeToTarget: 'Benutzerdefinierte Liste wählen',
    custom: 'Benutzerdefiniert ',
    selectTeachersYouWouldLikeToTarget: 'Lehrer wählen',
    staff: 'Mitarbeiter',
    selectYears: 'Jahre auswählen',
    selectClasses: 'Klassen auswählen',
    selectFromMyStudents: 'Aus meinen Schülern wählen',
    multipleClasses: 'Klassen',
    multipleYears: 'Jahrgänge',
    allStudents: 'Alle Schüler',
    done: 'Fertig',
    waitForTeachersToFeedYouWithSomeNewInformations: 'Auf Informationen der Lehrer warten',
    feedIsEmpty: 'Eingabefeld ist leer',
    thereIsNoFeedForThisSearch: 'Kein Ergebnis für diese Suche',
    createNewPostsForYourStudentsAndHereIsAShortcutForYou: 'Neuen Post erstellen',
    waitForTeacherToFeedYouWithSomeNewInformation: 'Auf Informationen der Lehrer warten',
    createFeedPost: 'Beitrag erstellen',
    targetList: 'Zielgruppe',
    beAmazing: 'Sei großartig!',
    login: 'Log In',
    getStarted: 'Los geht’s!',
    enterYourSchoolEmail: 'Gib deine Schulemailadresse ein',
    password: 'Passwort',
    email: 'E-Mail',
    requestNewPassword: 'Neues Passwort anfordern',
    newPassword: 'Neues Passwort',
    enterYourSchoolEmailAndWeWillSendYouALinkToGetBackIntoYourAccount: 'Gib deine Schulemailadresse ein und du erhälst eine E-Mail mit einem Bestätigungslink in deinen Account',
    sendRequest: 'Anfrage senden',
    verifyYourEmail: 'E-Mail bestätigen',
    weHaveSentYouALinkToGetBackIntoYourAccountAndCheckYourMailAndCopyYourTokenHere:
        'Wir haben dir einen Link geschickt, mit dem du wieder in dein Konto kommst. Prüfe deinen Posteingang und füge den Token hier ein. ',
    resendARequest: 'Anfrage erneut senden',
    didntGetAMail: 'Du hast keine E-Mail erhalten? ',
    submit: 'Teilen',
    enterYourNewPassword: 'Neues Passwort eingeben',
    apply: 'Anwenden',
    howDoYouFeel: 'Wie fühlst du dich?',
    'How do you feel?': 'Wie fühlst du dich?',
    poll: 'Abstimmung  ',
    thereAreNoAnswersOrFeedbacksForThisDay: 'Für diesen Tag gibt es keine Antworten oder Feedback',
    title: 'Titel',
    message: 'Nachricht ',
    requested: 'Angefragt',
    anonymous: 'Anonym',
    url: 'URL ',
    addPhoto: 'Foto hinzufügen',
    removePhoto: 'Foto entfernen',
    youAreAllDone: 'Fertig!',
    congratsEverythingIsDoneForNowWaitForNewTasks: 'Gratuliere, du bist fertig! Warte auf neue Aufgaben…',
    excellentWorkWeAreDelightedToHearThingsAreSoMuchBetter: 'Gut gemacht! Schön zu hören, dass es dir besser geht.',
    thisIsYourSafePlaceAndNothingWillBeShared: 'Das ist der private Teil deines Profils. Nur du kannst sehen was du schreibst.',
    enterANameForTodaysNotes: 'Benenne deinen heutigen Eintrag',
    iDontWantToSaveNotes: 'Ich möchte meine Einträge nicht speichern',
    worse: 'Schlechter',
    sorryToHearThatThingsAreWorseWhichOfTheFollowingWouldHelpRightNow:
        'Es tut uns leid zu hören, dass es dir schlechter geht. Welche von den Vorschlägen unten kann dir jetzt weiterhelfen?',
    muchWorse: 'Viel schlechter',
    sorryToHearThatThingsAreMuchWorseAndWhichOfTheFollowingWouldHelpRightNow:
        'Es tut uns leid zu hören, dass es dir viel schlechter geht. Welche von den Vorschlägen unten kann dir jetzt weiterhelfen?',
    same: 'Genauso',
    whatAreSomeIdeasToMakeThingsBetter: 'Was kannst du jetzt tun, um die Lage zu verbessern?',
    better: 'Besser',
    goodToHearThingsAreBetterAndWhatAreSomeIdeasToTakeItEvenFurther:
        'Schön zu hören, dass sich deine Lage verbessert hat. Hast du Ideen wie du sie vielleicht noch besser machen könntest? ',
    muchBetter: 'Viel besser',
    greatToHearThingsAreMuchBetterAndThinkAboutHowToImproveEvenMoreOrKeepItOnAPositiveLevel:
        'Schön zu hören, dass sich die Lage verbessert hat. Hast du Ideen wie du sie vielleicht noch besser machen könntest? ',
    ImOkWithIt: 'Das ist in Ordnung',
    IdPreferIfTheyWereBetter: 'Es wäre schön, wenn die Lage besser wäre',
    loadMoreSuggestions: 'Weitere Vorschläge',
    continue: 'Weiter',
    deleteNote: 'Eintrag löschen',
    today: 'Heute',
    comparedToLastTimeTodayIamFeeling: 'Verglichen mit dem letzten Mal fühle ich mich heute....',
    howDoYouFeelComparedToLastTimeYouDidThePoll: 'Wie fühlst du dich, verglichen mit der letzten Umfrage?',
    thisInformationWillBeSharedWith: 'Diese Info wird auch deine(n) Lehrer(in) geschickt',
    feelFreeToShareAnyThoughtsHereWhyYouFeelThisWay: 'Falls du Lust hast, kannst du hier beschreiben warum du dich so fühlst',
    feedback: 'Feedback',
    choose: 'Auswahl',
    newFeeds: 'Neue Einträge',
    openTasks: 'Offene Aufgaben',
    taskArchive: 'Aufgaben Archiv',
    congratsAndEverythingIsDoneForNowAndWaitForNewTasksFromYourTeacher: 'Gratuliere, alles ist erledigt! Warte auf neue Aufgaben von deinem Lehrer',
    newConversation: 'Neuer Chat',
    teacher: 'Lehrkraft',
    teachers: 'Lehrer:innen',
    counselor: 'Vertrauenslehrkraft',
    secretKey: 'Passwortschlüssel',
    advancedSettings: 'Erweiterte Einstellungen',
    showDailyReflectionScreen: 'Wie war mein Tag anzeigen',
    termsAndConditions: 'Geschäftsbedingungen',
    surname: 'Nachname',
    firstName: 'Vorname',
    gender: 'Geschlecht',
    Gender: 'Geschlecht',
    other: 'Andere ',
    Other: 'Andere ',
    thisIsYourSafePlace: 'Hier bist du sicher  ',
    thisIsYourPrivateRoom: 'Dies ist der private Teil deines Profil, in den nur Du Einsicht hast.',
    safePlaceWithDailyReflectionNotes: 'Diese Notizen kannst nur du sehen',
    personalInformation: 'Persönliche Informationen',
    privacyAndSecurity: 'Datenschutz ',
    dashboard: 'Überblick',
    update: 'Aktualisieren',
    unselect: 'Auswahl aufheben',
    noResults: 'Keine Ergebnisse',
    open: 'Öffnen',
    share: 'Teilen',
    back: 'Zurück',
    backToRoleSelection: 'Zurück zur Rollenauswahl',
    task: 'Aufgabe',
    tasks: 'Aufgaben',
    logout: 'Ausloggen',
    save: 'Speichern',
    name: 'Name',
    profile: 'Profil',
    classroom: 'Klassenzimmer',
    feed: 'Feed',
    live: 'Live',
    archive: 'Archiv',
    yesterday: 'Gestern',
    tomorrow: 'Morgen',
    results: 'Ergebnisse',
    required: 'Erforderlich',
    schedule: 'Zeitplan',
    happy: 'glücklich',
    excited: 'aufgeregt',
    ecstatic: 'begeistert',
    inspired: 'inspiriert',
    calm: 'ruhig',
    lethargic: 'träge',
    grumpy: 'verärgert',
    sad: 'traurig',
    stressed: 'gestresst',
    angry: 'wütend',
    sunday: 'Sonntag',
    monday: 'Montag',
    tuesday: 'Dienstag',
    wednesday: 'Mittwoch',
    thursday: 'Donnerstag',
    friday: 'Freitag',
    saturday: 'Samstag',
    scheduled: 'Geplant',
    delivered: 'Gesendet',
    first: 'Erste ',
    second: 'Zweite',
    third: 'Dritte',
    seen: 'Gesehen',
    selectStaff: 'Mitarbeiter auswählen',
    forgotPassword: 'Passwort vergessen?',
    repeatPassword: 'Passwort wiederholen',
    retypePassword: 'Passwort erneut eingeben',
    changePassword: 'Passwort ändern',
    hidePassword: 'Passwort ausblenden',
    dailyFeedback: 'Tägliches Feedback',
    createNew: 'Erstelle neu',
    selectionType: 'Auswahl',
    enterSurname: 'Nachnamen eingeben',
    enterEmail: 'E-Mail eingeben',
    newMessage: 'Neue Nachricht!',
    myTasks: 'Meine Aufgaben',
    addOption: 'Option hinzufügen',
    newQuestion: 'Neue Frage',
    editQuestion: 'Frage bearbeiten',
    editPost: 'Beitrag bearbeiten',
    editPoll: 'Abstimmung bearbeiten',
    editGroup: 'Gruppe bearbeiten',
    tomorrowPlans: 'Pläne für morgen',
    confirmStopping: 'Bestätigen Sie das Anhalten',
    newPoll: 'Neue Abstimmung',
    answer: 'Antworten',
    post: 'Post',
    hi: 'Hallo',
    lastTime: 'Letztes Mal',
    suggestions: 'Vorschläge',
    sendAnswer: 'Antwort senden',
    comment: 'Kommentar',
    ok: 'OK',
    passwordMustBeLongerThan8CharactersAndMustContainsUppercaseLowercaseNumberAndSpecialSymbol:
        'Passwort muss länger als 8 Zeichen haben und muss Groß-, und Kleinbuchstaben, Zahlen und Sonderzeichen enthalten',
    enterYourWorkEmailAndPassword: 'Login E-Mail eingeben',
    submitNewPassword: 'Neues Passwort bestätigen',
    pleaseCheckYourMailToConfirmYourEmailAddress: 'Wir haben eine E-Mail an dich geschickt, um die Adresse zu bestätigen. Bitte klick auf die Bestätigung in der E-Mail',
    howDoYouFeelAboutThingsBeingTheSameToday: 'Wie denkst du darüber, dass es dir heute genauso geht?',
    pollHasBeenUpdated: 'Abstimmung wurde aktualisiert',
    typeAPostTitle: 'Titel eingeben',
    addAnOptionalMessage: 'Schreib eine Nachricht',
    writeYourMessageHere: 'Hier Nachricht schreiben',
    enterUrlLink: 'Web-Link eingeben',
    saveAndContinue: 'Sichern und weiter',
    nameOfTodayNote: 'Name für die heutige Notiz',
    whatAreJust3GoodThingsThatHappenedToday: 'Welche drei Dinge waren heute gut?',
    yourDirectManager: 'Dein direkter Manager',
    secretKeyHasBeenSaved: 'Sicherheitscode gespeichert',
    enterYourSecretKeyToEncryptLllYourMessagesAndAnswers: 'Gib hier einen persönlichen Sicherheitscode ein, um deine Notizen zu verschlüsseln',
    enterSecretKey: 'Sicherheitscode eingeben',
    locked: 'Gesperrt',
    thisNoteIsEncryptedEnterYourSecretKeyToReadIt: 'Diese Notiz ist verschlüsselt. Gib deinen Sicherheitscode ein, um sie zu lesen.',
    unlockYourNotes: 'Notizen entsperren',
    enterTheSecretKeyYouUsedForTheseNotes: 'Gib den Sicherheitscode ein, den du für diese Notizen verwendet hast. Bereits eingegebene Codes bleiben entsperrt.',
    thatKeyDidNotUnlockAnyNotes: 'Mit diesem Code ließ sich keine Notiz entsperren. Bitte prüfe ihn und versuche es erneut.',
    advancedSettingsAreSuccessfullySaved: 'Die zusätzlichen Einstellungen sind gespeichert',
    youCanUseTheButtonsAboveToContactYourTeacherOrCounselorForSupportAtAnyPoint: 'Du kannst die Felder oben benutzen, um deinen Lehrer oder Vertrauenslehrer zu kontaktieren',
    waitForStudentsToContactYouToHelpThem: 'Hier werden die Nachrichten der Schüler sein, die dich kontaktieren',
    passwordsDoNotMatch: 'Passwörter sind nicht identisch',
    startNewChat: 'Neuen Chat starten',
    shareWithTeacher: 'Mit dem Lehrer teilen',
    tasksForThisSection: 'Aufgaben in diesem Bereich',
    howWasYourDay: 'Wie war dein Tag?',
    thisIsAutoReplyMessage: 'Dies ist eine automatische Nachricht',
    thankYouForReachingOutWeWillReplyToYourMessageSoonIfYouOrSomeoneYouKnowIsInImmediateDangerPleaseCallEmergencyServices:
        'Vielen Dank für deine Nachricht. Wir werden dir sobald wie möglich antworten.',
    doYouThinkThingsAreForAnyReasonInParticular: 'Denkst du, dass es einen bestimmten Grund gibt, warum du dich {{result}} fühlst?',
    yourPrivateNotes: 'Persönliche Notizen',
    createNewPoll: 'Neue Abstimmung starten',
    saveAsTemplate: 'Als Vorlage speichern',
    addPostContentHere: 'Hier den Inhalt des Beitrags hinzufügen',
    typeAPollQuestion: 'Hier die Frage für die Abstimmung eingeben',
    questionHasBeenUpdated: 'Frage wurde aktualisiert',
    questionHasBeenPosted: 'Frage wurde verschickt',
    iDontWantToThinkAboutThisNow: 'Ich möchte da jetzt nicht drüber nachdenken',
    appVersion: 'Anwendungsversion',
    selectLanguage: 'Sprache auswählen',
    userIsUpdated: 'Benutzer ist aktualisiert',
    imageIsNotUploaded: 'Bild ist nicht hochgeladen',
    feedHasBeenUpdated: 'Feed wurde aktualisiert',
    permissionIsNotAccepted: 'Erlaubnis ist nicht akzeptiert',
    feedHasBeenPosted: 'Feed wurde veröffentlicht',
    pollHasBeenPosted: 'Abstimmung wurde veröffentlicht',
    templateHasBeenSaved: 'Vorlage wurde gespeichert',
    privateNoteHasBeenSaved: 'Private Notiz wurde gespeichert',
    compareToLastTime: 'Vergleiche mit dem letzten Mal',
    yourAnswerIsSaved: 'Ihre Antwort ist gespeichert',
    staySecuredFirst: 'Bleib zuerst gesichert',
    day: 'Tag',
    dateOfBirth: 'Geburtsdatum',
    teacherInfo: 'Lehrer Details',
    studentInfo: 'Schüler:in Details',
    manage: 'Bearbeiten',
    openListWithAllClassesFromThisSchool: 'Liste mit allen Klassen öffnen, die zu dieser Schule gehören',
    wizardToCreateNewClassAddStudentsAndHeaTteacher: 'Hier neue Klasse, neue Schüler und einen Leiter hinzufügen',
    openListWithAllTeachersThatGoToThisSchool: 'Liste mit allen Lehrern öffnen, die zu dieser Schule gehören',
    wizardToCreateNewTeacherAndLinkItToProperClass: 'Hier neuen Lehrer hinzufügen und einer Klasse zuordnen',
    chooseDataRange: 'Wähle den Datenbereich',
    thisListRepresentsAllContentFromThisTypeYouCanEditOrDeleteTt: 'Diese Liste zeigt alle Inhalte dieser Art. Du kannst sie verändern oder löschen',
    lastCreatedpoll: 'Letzte Abstimmung',
    lastCreatedfeed: 'Letzter Feed',
    lastCreatedquestion: 'Letzte Frage',
    listOfDays: 'Liste der Tage',
    selectThisquestion: 'Diese Umfrage',
    selectThispoll: 'Diese Abstimmung wählen',
    selectThisfeed: 'Diesen Feed wählen',
    createOwn: 'Eigene Version machen',
    showAllContent: 'Alle Inhalte zeigen',
    programDuration: 'Programm Dauer',
    seeThisProgram: 'Dieses Programm verwenden',
    programs: 'Programme',
    Programs: 'Programme',
    hereYouCanCreateAPollToLearnMoreAboutYourStudents: 'Hier kannst du eine Umfrage starten und mehr über deine Schüler erfahren',
    askAnOpenQuestionToGetDetailedFeedback: 'Stelle hier eine offene Frage, um detaillierte Antworten zu bekommen',
    classManagement: 'Klassen bearbeiten',
    teacherManagement: 'Lehrer:innen bearbeiten',
    inactivity: 'Inaktivität',
    new: 'Neu',
    inactivitySettings: 'Inaktivitätseinstellungen',
    'Control how inactivity is measured and who gets alerted.': 'Legen Sie fest, wie Inaktivität gemessen wird und wer benachrichtigt wird.',
    'Failed to save settings': 'Einstellungen konnten nicht gespeichert werden',
    'Enter a valid start date with a four-digit year.': 'Geben Sie ein gültiges Startdatum mit einer vierstelligen Jahreszahl ein.',
    'Enter a valid end date with a four-digit year.': 'Geben Sie ein gültiges Enddatum mit einer vierstelligen Jahreszahl ein.',
    'Start date cannot be after end date.': 'Das Startdatum darf nicht nach dem Enddatum liegen.',
    '{{n}} never active': '{{n}} nie aktiv',
    '{{n}} recently lapsed': '{{n}} kürzlich inaktiv',
    'not active in the past {{days}} days': 'in den letzten {{days}} Tagen nicht aktiv',
    'No matches for': 'Keine Treffer für',
    'Last active': 'Zuletzt aktiv',
    'Loading...': 'Wird geladen...',
    analyze: 'Analytik',
    instructionVideos: 'Erklärungsvideos',
    created: 'Erstellt',
    pickOneOption: 'Wähle eine Option',
    listOfClasses: 'Liste der Klassen',
    newClass: 'Neue Klasse',
    action: 'Handlung',
    numberOfStudents: 'Anzahl der Schüler:innen',
    listOfTeachers: 'Liste der Lehrer',
    newTeacher: 'Neue Lehrer',
    options: 'Optionen',
    refresh: 'Aktualisieren',
    selectDate: 'Datum auswählen',
    time: 'Zeit',
    date: 'Datum',
    Repaet: 'Wiederholen',
    feedDescription: 'Hier kannst du Text, Bilder, Vidoes or Links hinzufuegen',
    studentsLoginData: 'Schüler Login Daten',
    listOfStudentsWhoHaventLoggedInYet: 'Liste von Schülern und Schülerinnen, die sich noch nicht eingeloggt haben',
    'Open list': 'Öffnen',
    'Number of answers': 'Anzahl der Antworten',
    user: 'Benutzer',
    easilyManageYourStudentsAndTeachersWithSeparateFunctions: 'Verwalte deine Schüler und Lehrer einfach mit getrennten Funktionen',
    userManagement: 'Benutzerverwaltung',
    and: 'und',
    chat: 'Chat',
    trackCounseling: 'Beratung nachverfolgen',
    openLink: 'Link öffnen',
    openListOfUsersWhoHaventLoggedIn: 'Öffne die Liste der Benutzer, die sich nicht angemeldet haben',
    loadMoreClasses: 'Mehr Klassen laden',
    loginInfo: 'Login Information',
    role: 'Rolle',
    loadMore: 'Mehr laden',
    noTeachersYet: 'Noch keine Lehrer',
    classInfo: 'Klassen Information',
    enterClassName: 'Geben Sie den Klassennamen ein',
    enterSchoolYear: 'Geben Sie das Schuljahr ein',
    schoolYear: 'Schuljahr',
    className: 'Klassennamen',
    listOfStudents: 'Schülerliste',
    doYouWantToRemoveStudent: 'Möchten Sie den Schüler löschen?',
    doYouWantToDeleteClass: 'Möchten Sie die Klasse löschen?',
    emailIsInvalid: 'E-Mail ist ungültig.',
    emailIsAvailable: 'E-Mail ist verfügbar!',
    emailAlreadyExists: 'E-Mail existiert bereits!',
    fieldIsRequired: 'Feld ist erforderlich',
    showPassword: 'Passwort anzeigen',
    enterName: 'Name eingeben',
    selectRole: 'Rolle auswählen',
    teachersRoleNotSetYet: 'Lehrrolle noch nicht ausgewählt',
    create: 'Schaffen',
    doYouWantToDeleteTeacher: 'Möchten Sie den Lehrer löschen?',
    classIsCreated: 'Die Klasse ist gemacht!',
    reminderForToday: 'Erinnerung für heute',
    closed: 'abgeschlossen',
    youDontHaveAnyRemindersForToday: 'Du hast keine Erinnerungen für heute',
    firstEnterANote: 'Gib zuerst eine Notiz ein',
    noteIsCreated: 'Notiz wird erstellt',
    reminderHasBeenChanged: 'Erinnerung wurde geändert!',
    status: 'Status',
    exportReport: 'Bericht exportieren',
    notes: 'Notizen',
    Notes: 'Notizen',
    editReminder: 'Erinnerung bearbeiten',
    removeReminder: 'Erinnerung löschen',
    enterYourNoteHere: 'Notiz hinzufügen',
    createANote: 'Notiz erstellen',
    addReminder: 'Erinnerung hinzuffügen',
    teacherLogin: 'Lehrer-Login',
    enterCredentialsYouReceivedFromSchool: 'Gib deine Schul- Anmeldedaten ein',
    deletePost: 'Beitrag löschen',
    doYouWantToDeletePost: 'Möchten Sie diesen Eintrag löschen?',
    setDateForReminderOfStudent: 'Setze ein Datum, an dem du an diese(n) Schüler(in) erinnert werden möchtest',
    createReminder: 'Erinnerung erstellen',
    writeFullAnswerHere: 'Schreibe deine Antwort hier aus',
    stop: 'Beenden',
    answers: 'Antworten',
    actionTaken: 'Fall in Bearbeitung',
    iWillTakeAction: 'Ich werde mich kümmern',
    seenBy: 'Gesehen von',
    thereAreNoAnswersForThatDay: 'Es gibt keine Antworten für diesen Tag ...',
    describeHowYouWillDealWithThisStudent: 'Beschreibe, wie du mit diesem Schüler umgehen wirst ',
    writeYourThoughtsHere: 'Hier kannst du deine Gedanken dazu aufschreiben',
    studentData: 'Schülerdaten',
    student: 'Schüler:in',
    enterStudentUPN: 'UPN eingeben',
    showAll: 'Alles zeigen',
    loginStatistic: 'Login-Statistiken',
    hereYouCanAddTextImagesVideosOrLinks: 'Hier können Sie Texte, Bilder, Videos oder Links hinzufügen',
    typeAQuestionTitle: 'Geben Sie einen Fragetitel ein',
    typeYourHeadlineHere: 'Geben Sie hier Ihre Überschrift ein',
    optional: ' (Optional)',
    invalidLink: 'Ungültiger Link',
    chooseTemplateFor: 'Vorlage auswählen für ',
    doYouWantToDeleteThis: 'Willst du das löschen?',
    deleteThisRunOnly: 'Nur diesen Durchlauf löschen',
    deleteAllScheduledRuns: 'Diesen und alle geplanten Durchläufe löschen',
    stopThisRun: 'Nur diesen Durchlauf stoppen',
    stopAndRemoveScheduled: 'Stoppen und alle geplanten Durchläufe entfernen',
    doYouWantToStopThis: 'Willst du das stoppen?',
    scheduledRuns_one: '{{count}} geplanter Durchlauf',
    scheduledRuns_other: '{{count}} geplante Durchläufe',
    recurringContent: 'Wiederkehrender Inhalt',
    seriesDeleted: 'Inhalt und geplante Durchläufe gelöscht',
    seriesStopped: 'Inhalt gestoppt und geplante Durchläufe entfernt',
    yourDataIsUpdated: 'Deine Daten werden aktualisiert!',
    yourDataIsNotUpdated: 'Deine Daten werden nicht aktualisiert!',
    contentIsCreated: 'Inhalt wird erstellt!',
    contentIsNotCreated: 'Inhalt wird nicht erstellt!',
    templateIsCreated: 'Vorlage ist erstellt!',
    templateIsNotCreated: 'Vorlage wird nicht erstellt!',
    allCreatedContent: 'Alle erstellten Inhalte',
    runProgram: 'Programm starten',
    teachersOnly: 'Nur für Lehrer',
    programTitle: 'Programmtitel',
    thisToolHelpsYouPlanTheEntireProgramOnce: 'Dieses Werkzeug hilft dir, das gesamte Programm einmal zu planen, damit du es nicht ständig überprüfen musst',
    startDate: 'Anfangsdatum',
    selectDays: 'Tage wählen',
    pickTime: 'Zeit wählen',
    thisProgaramIsAlreadyRunning: 'Dieses Programm wird bereits ausgeführt, erneut ausführen?',
    youAreRunningThisProgramSuccessfully: 'Sie führen dieses Programm erfolgreich aus',
    surveys: 'Umfragen',
    Surveys: 'Umfragen',
    survey: 'Umfrage',
    description: 'Beschreibung',
    typeASurveyTitle: 'Umfragetitel erstellen',
    addASurveyDescription: 'Umfragenbeschreibung hinzufügen',
    surveyTitle: 'Umfragetitel',
    section: 'Abschnitt',
    sections: 'Abschnitte',
    enterSectionTitleHere: 'Abschnittstitel hinzufügen',
    enterSectionDescriptionHere: 'Abschnittsbeschreibung hinzufügen',
    enterQuestionHere: 'Frage hinzufügen',
    openAnswer: 'Antwort öffnen',
    addQuestion: 'Frage hinzufügen',
    addSection: 'Kategorie hinzufügen',
    deleteSurvey: 'Umfrage löschen',
    doYouWantToRemoveSurvey: 'Möchten Sie die Umfrage löschen?',
    yesNo: 'Ja/Nein',
    confirmation: 'Bestätigung',
    manageRunningPrograms: 'Laufende Programme verwalten',
    numberOfSections: 'Anzahl der Abschnitte',
    thisToolHelpsYouToControlAllRunningProgramsAndTrackTheirInfluenceToStudents:
        'Dieses Tool hilft dir, alle laufenden Programme zu verwalten und ihren Einfluss auf die Schüler:innen zu beobachten',
    currentPrograms: 'Aktuelle Programme',
    yourRunningProgramListIsEmptyStartByAddingOneFromTheListOfPrograms:
        'Deine Liste laufender Programme ist leer. Starte ein Neues, indem du eines von der Programmliste auswählst',
    deleteProgram: 'Programm löschen',
    days: 'Tagen',
    surveyIsCreated: 'Umfrage wird erstellt',
    yes: 'Ja',
    no: 'Nein',
    Yes: 'Ja',
    No: 'Nein',
    configureSurvey: 'Umfrage konfigurieren',
    editSurvey: 'Umfrage bearbeiten',
    runSurvey: 'Umfrage starten',
    selectMyStudents: 'Wählen Sie meine Schüler.',
    openFavorites: 'Favoriten öffnen',
    thereIsNoDataToShow: 'Keine Daten zum Anzeigen ',
    selectAll: 'Wählen Sie Alle',
    deselectAll: 'Alle abwählen',
    saveAsFavorite: 'Als Favorit speichern',
    doYouWantToDeleteFavorite: 'Möchten Sie die Favoritengruppe löschen?',
    saveYourFavoriteGroup: 'Speichern Sie Ihre Lieblingsgruppe',
    deleteWasSuccessful: 'Löschen war erfolgreich',
    listOf: 'Liste: ',
    deleteThis: 'Lösch das:',
    editThis: 'Bearbeite dies',
    youHaveNoChats: 'Du hast noch keine Chats',
    reminderSetFor: 'Erinnerung eingestellt für ',
    doYouWantToDeleteThisTask: 'Möchten Sie diese Aufgabe löschen?',
    assignedTo: 'Für:',
    selectTeacher: 'Lehrer:in auswählen',
    wellbeingTracker: 'Wellbeing Tracker',
    open_poll: 'Nicht-anonyme Abstimmung',
    open_question: 'Nicht-anonyme Frage',
    open_survey: 'Nicht-anonyme Umfrage',
    students: 'Schüler:innen',
    assignedActions: 'Zugewiesene Aktionen',
    reminder: 'Erinnerung',
    youDontHaveAnyAssignedAction: 'Sie haben keine zugewiesene Aktion',
    'Take it': 'Speichern',
    'How are you?': 'Wie geht es Dir?',
    'Type an action': 'Aktion hier eingeben',
    'Do you want to close this counseling profile?': 'Möchten Sie dieses Beratungsprofil schließen?',
    'Do you want to open this counseling profile?': 'Möchten Sie dieses Beratungsprofil öffnen?',
    'This counseling profile is open!': 'Dieses Beratungsprofil ist offen!',
    'This counseling profile is closed!': 'Dieses Beratungsprofil ist geschlossen!',
    'Reminder has been removed!': 'Die Erinnerung wurde entfernt!',
    'Assign action': 'Aktion zuweisen',
    'Export data': 'Daten exportieren',
    'Message only visible to staff with special access': 'Nachricht nur für Mitarbeiter mit speziellem Zugang sichtbar',
    'Set a date when you would like to be reminded about this student': 'Legen Sie ein Datum fest, an dem Sie an diesen Schüler erinnert werden möchten',
    'Message is visible to all': 'Nachricht ist für alle sichtbar',
    'Choose a date': 'Wählen Sie ein Datum',
    'Teacher is created and password has been sent!': 'Lehrer ist erstellt und Passwort wurde gesendet!',
    'Teacher is not created!': 'Lehrkraft ist nicht erstellt!',
    'Teacher is removed!': 'Lehrer wurde entfernt!',
    'Teacher is not removed!': 'Lehrer wurde nicht entfernt!',
    'Unregistered teachers': 'Nicht registrierte Lehrer',
    'Unregistered users': 'Nicht registrierte Benutzer',
    'Registered teachers': 'Registrierte Lehrer',
    'Registered users': 'Registrierte Benutzer',
    'Login data': 'Anmeldedaten',
    'Current Emotion': 'Aktuelle Emotion',
    'Add a teacher': 'Lehrkraft hinzufügen',
    'Add a new class': 'Neue Klasse hinzufügen',
    'Last login': 'Letzter Log in',
    'Most Popular Emotion': 'Am häufigsten gewählte Emotionen',
    'Type any additional text here': 'Zusätzlichen Text hier eingeben',
    chooseTheAnswer: 'Wähle eine Antwort',
    findTheRightSolution: 'Finde die richtige Lösung',
    '7 Days': '7 Tage',
    '3 Months': '3 Monate',
    '1 Month': '1 Monat',
    '1 Year': '1 Jahr',
    'Add note': 'Notiz hinzufügen',
    'User activity': 'Benutzeraktivität',
    'Stop editing': 'Hör auf zu bearbeiten',
    'Student is created!': 'Schüler:in ist erstellt!',
    'Student is not created!': 'Schüler:in ist nicht erstellt!',
    'All emotions': 'Alle Emotionen',
    'Trend of your classrooms': 'Klassenzimmer Trends',
    'Your Upstrive (Tasks)': 'Deine Upstrive (Aufgaben)',
    'Write the answer': 'Schreibe die Antwort',
    assignAction: 'Aktion zuweisen',
    AssignActionToATeacherToCheckOnThisStudent: 'Lehrkraft mit der Kontrolle dieses Schülers / dieser Schülerin beauftragen',
    assignToTeacher: 'Lehrkraft zuweisen',
    chooseFromOurRangeOfReadyToGoProgramsDesignedToSupportYourStudentsAndSaveYouTimesNow:
        'Aus einer Auswahl fertiger Programme wählen, um deine Schüler zu unterstützen und um Zeit zu sparen',
    journals: 'Tagebücher',
    Journals: 'Tagebücher',
    createAQuestion: 'Frage erstellen',
    turnOff: 'Ausschalten',
    staffLogin: 'Mitarbeiter/-innen Login',
    token: 'Wertmarke',
    createYourOwn: 'Inhalte selbst erstellen',
    readyToGo: 'Ready-to-go',
    favorites: 'Favoriten',
    addToFavorites: 'Zu Favoriten hinzufügen',
    repeat: 'Wiederholen',
    thisSurveyCanBeAnalyzed: 'Diese Umfrage kann analysiert werden',
    doesNotRepeat: 'Wiederholt sich nicht',
    onceAWeek: 'Einmal pro Woche',
    onceAMonth: 'Einmal pro Monat',
    repeatsOn: 'Wiederholt sich am',
    every: 'Jeden',
    ofEveryMonth: 'jeden Monats',
    addToWellbeingTracker: 'Zum Wellbeing Tracker hinzufügen',
    addToAnalytics: 'Zu Analysen hinzufügen',
    open_journal: 'Vertrauliches Tagebuch',
    actionComment: 'Kommentar zur Aktion',
    lastNote: 'Letzte Anmerkung',
    Overdue: 'Überfällig',
    currentEmotion: 'Aktuelle Emotion',
    mostPopularEmotion: 'Am häufigsten gewählte Emotionen',
    messageIsVisibleToAll: 'Nachricht ist für alle sichtbar',
    messageOnlyVisibleToStaffWithSpecialAccess: 'Nachricht nur für Mitarbeiter mit speziellem Zugang sichtbar',
    assignActionSuccess: 'Aktion erfolgreich zugewiesen',
    filterIsNotSet: 'Filter wurde nicht angewendet',
    commentHasBeenSeen: 'Kommentar wurde gesehen!',
    catchUp: 'Catch-up',
    catchUpOnAnyStudentCommentsAttachedTo: 'Nacharbeiten von Kommentaren der Schüler:innen zu unangenehmen Gefühlen, die möglicherweise übersehen wurden',
    unseen: 'Ungelesen',
    markAsSeen: 'Als gesehen markieren',
    fullTraining: 'Komplettes Training',
    individualFeaturesTraining: 'Individuelles Fertigkeiten Training',
    instructionVideosForStaff: 'Anleitungsvideo für Mitarbeiter/-innen',
    deleteYourPrivateNote: 'Willst du diese private Notiz wirklich löschen?',
    emotions: 'Emotionen',
    Emotions: 'Emotionen',
    studentRemoved: 'Schüler/-in wurde entfernt',
    fileHasBeenUploadedDataWillBeUpdatedWithin24Hours: 'Datei wurde hochgeladen. Die Daten werden in den nächsten 24 Stunden erneuert.',
    Neutral: 'Neutral',
    downloadTemplateFile: 'Vorlage-Datei herunterladen',
    previousUploads: 'Vorherige Uploads',
    fileLink: 'Dateien link',
    attachFile: 'Datei anhängen',
    uploadData: 'Datei hochladen',
    noUnsignedTeachers: 'Keine unsignierten Lehrer/-innen',
    noUnsignedStudents: 'Keine unsignierten Schüler:innen',
    reviewYourLoginStatistics: 'Überprüfe deine Anmeldestatistiken',
    registeredStudents: 'Registrierte Schüler:innen',
    unregisteredStudents: 'Unregistrierte Schüler:innen',
    uploadUserData: 'Benutzerdaten hochladen',
    addATeacher: 'Lehrkraft hinzufügen',
    addANewClass: 'Neue Klasse hinzufügen',
    enterStudentsDetails: 'Schüler:innen Details hinzufügen',
    enterTeachersDetails: 'Lehrer/-innen Details hinzufügen',
    cantCreateStudentWithoutCreateClass: 'Schüler/-in kann nicht ohne Klasse hinzugefügt werden',
    createWellbeingProfile: 'Wellbeing Profil erstellen',
    yourStudentListIsEmpty: 'Deine Schüler:innen Liste ist leer',
    addAStudent: 'Schüler/-in hinzufügen',
    openClassQRCodes: 'Klassen-QR-Codes öffnen',
    generatingClassQRCodes: 'QR-Codes werden erstellt…',
    print: 'Drucken',
    noActiveStudentsForQR: 'Diese Klasse hat keine aktiven Schüler/-innen, für die QR-Codes erstellt werden können.',
    letThemSetTheirOwnPasswordsAfterLogin: 'Eigenes Passwort nach erstem Login erstellen lassen',
    keepThisPassword: 'Dieses Passwort behalten',
    rolemodelIsnotLoaded: 'Beispiel konnte nicht geladen werden...Lade die Seite erneut!',
    loginData: 'Anmeldedaten',
    exportData: 'Daten exportieren',
    passwordIsNotCorrect: 'Passwort stimmt nicht',
    closePopUp: 'Pop-up schließen',
    deleteStudent: 'Schüler:in löschen',
    deleteTeacher: 'Lehrkraft löschen',
    hidePasswordmanager: 'Passwort-Manager ausblenden',
    setStudentsPasswordManually: 'Schüler:innen Passwort manuell auswählen',
    generateNewPassword: 'Neues Passwort erstellen',
    lastName: 'Nachname',
    noStudentsYet: 'Keine Schüler:innen bisher',
    loggedIn: 'Eingeloggt',
    noAnswer: 'Keine Antworten',
    changeStatus: 'Status ändern',
    answerOnHowAreYou: 'Antwort zu "Wie geht es dir?"',
    teacherRole: 'Lehrer/-innenrolle',
    'Select this teacher’s role': 'Lehrer/-innen Rolle auswählen',
    thisTeacherWillbe: 'Dieser Lehrer wird',
    itAccess: 'IT Access',
    itAccessRightText: 'Nutzerverwaltung',
    itAccessConfirm: 'Dieser Lehrer kann Nutzer nur über die Web-App verwalten.',
    noPermissionTitle: 'Sie haben keine Berechtigung, diese Seite anzuzeigen',
    noPermissionSubtitle: 'Ihre IT-Access-Rolle ist auf die Nutzerverwaltung beschränkt.',
    goToUserManagement: 'Zur Nutzerverwaltung',
    negative: 'Negativ',
    classIsUpdated: 'Klasse ist aktualisiert',
    classIsNotUpdated: 'Klasse ist nicht aktualisiert',
    teacherIsCreatedAndPasswordHasBeenSent: 'Lehrer ist erstellt und Passwort wurde gesendet!',
    teacherIsNotCreated: 'Lehrkraft ist nicht erstellt!',
    createYourOwnContent: 'Erstelle deinen eigenen Inhalt',
    contentDeleted: 'Inhalt gelöscht',
    upcomingContent: 'Zukünftige Events',
    overview: 'Übersicht',
    feedPosts: 'Feed Post',
    welcomeBack: 'Willkommen zurück',
    ofStudentsUsingHowAreYouTodayAtLeastOncePerWeek: '% der Schüler:innen benutzen "Wie geht es dir heute?" mindestens einmal pro Woche',
    yourClassroom: 'Dein Klassenzimmer',
    checkWhatsGoingOn: 'Sieh dir an was gerade los ist',
    myClassroom: 'Mein Klassenzimmer',
    youDeletedTargetGroup: 'Zielgruppe löschen',
    deeperInsights: 'Tiefere Einblicke',
    findYourStudentsWhoAreLoggingUncomfortableEmotions: 'Finde Schüler:innen die negative Emotionen angeben ',
    monitoringGroups: 'Gruppe kontrollieren',
    createGroup: 'Gruppe erstellen',
    whatIsIt: 'Was ist das?',
    createdNewMonitoringGroup: 'Neue Kontrollgruppe erstellen!',
    updatedMonitoringGroup: 'Kontrollgruppe aktualisieren',
    nameANewGroup: 'Neue Gruppe benennen',
    chooseEmotions: 'Emotion wählen',
    close: 'Schließen',
    actionRequired: 'Maßnahmen erforderlich',
    stayUpToDateWithStudentSupport: 'Bleibe am Laufenden mit der Unterstützung deiner Schüler:innen',
    actionsAssignedToMe: 'Mir zugewiesene Maßnahmen',
    studentChat: 'Schüler/-innen Chat',
    unreadMessage: 'ungelesene Nachricht',
    unreadMessage_zero: 'Keine ungelesenen Nachrichten',
    unreadMessage_one: '{{count}} ungelesene Nachricht',
    unreadMessage_other: '{{count}} ungelesene Nachrichten',
    assignedBy: 'Zugewiesen durch',
    addNote: 'Notiz hinzufügen',
    engagementStatistics: 'Engagement-Statistik',
    trackEngagementResponsivenessLogins: 'Engagement, Antwortverhalten und Anmeldungen verfolgen',
    analytics: 'Analysen',
    ofStudentsUsingUpstriveWeekly: '% aller Schüler:innen nutzen Upstrive wöchentlich',
    ofResponsesToActivePollsQuestion: '% der Antworten auf aktive Umfragen',
    ofTeachersLoggedIn: '% der Lehrkräfte haben sich angemeldet',
    ofStudentsLoggedIn: '% der Schüler:innen haben sich eingeloggt',
    displayAll: 'Alle anzeigen',
    'display all': 'Alle anzeigen',
    'Display all': 'Alle anzeigen',
    onlyMine: 'Nur meine',
    searchResults: 'Antworten durchsuchen',
    filter: 'Filter',
    from: 'Von',
    to: 'Bis',
    notSelected: 'Nicht ausgewählt',
    questions: 'Fragen',
    Questions: 'Fragen',
    polls: 'Abstimmungen',
    Polls: 'Abstimmungen',
    runReadyToGo: 'Ready-to-go Inhalte verwenden',
    journal: 'Tagebuch',
    target: 'Zielgruppe',
    clickToBrowseResults: 'Klicke, um Ergebnisse anzuzeigen',
    by: 'Von',
    archived: 'Archiviert',
    download: 'Download',
    thereIsntAnyAnswerYet: 'Es gibt bisher keine Antworten',
    start: 'Start',
    createPosts: 'Beitrag erstellen',
    deleteFeedContent: 'Beiträge löschen?',
    congratulations: 'Herzlichen Glückwunsch',
    youHaveCompletedAllYourTasks: 'Du hast alle Aufgaben erledigt',
    submitAnswer: 'Antwort abgeben',
    'Take Survey': 'Umfrage starten',
    runReadyToGoContent: 'Ready-to-go Inhalte verwenden',
    yourFeedBackHasBeenSubmited: 'Deine Rückmeldung wurde gespeichert',
    useTemplate: 'Vorlage verwenden',
    templateDeleted: 'Vorlage wurde gelöscht',
    fileIsToBig: 'Datei ist zu groß!',
    templateIsUpdated: 'Die Vorlage wurde aktualisiert.',
    templateIsNotUpdated: 'Die Vorlage wurde nicht aktualisiert.',
    templateIsNotDeleted: 'Die Vorlage wurde nicht gelöscht.',
    contentNeedsToBeReviewedByTheScoolAdmin: 'Der Inhalt muss von der Schulleitung überprüft werden!',
    headline: 'Überschrift',
    typeHeadlineHere: 'Gebe die Überschrift hier ein',
    supportiveText: 'Unterstützender Text',
    enterLinkOptional: 'Link hinzufügen (optional)',
    writeOption1Here: 'Schreibe hier Option 1 hinein',
    deleteOption: 'Option löschen',
    'Select target': 'Auswählen',
    pleaseFillRequiredFields: 'Pflichtfelder ausfüllen',
    updateTemplate: 'Vorlage hochladen',
    templateIsSaved: 'Vorlage wurde gespeichert!',
    publish: 'Veröffentlichen',
    surveyIsCreatedAsTemplate: 'Umfrage wurde als Vorlage gespeichert!',
    surveyIsDeleted: 'Umfrage wurde gelöscht!',
    moveSectionUp: 'Sektion nach oben verschieben',
    moveSectionDown: 'Sektion nach unten verschieben',
    headlineForSection: 'Überschrift für die Sektion',
    descriptionForSection: 'Beschreibung für die Sektion',
    moveQuestionUp: 'Frage nach oben verschieben',
    moveQuestionDown: 'Frage nach unten verschieben',
    selectTypeOfQuestion: 'Fragentyp wählen',
    writeOption: 'Schreibe hier Option {{result}} hinein',
    setupADateAndTime: 'Zeit und Datum festlegen',
    weekly: 'Wöchentlich',
    monthly: 'Monatlich',
    everyMonthOn: 'Jeden Monat am',
    endDate: 'Enddatum',
    selectACategory: 'Wähle eine Kategorie',
    selectSpecificYearGroupsToGatherMoreInformationFrom: 'Wähle eine Schulstufe aus, um über sie weitere Informationen zu erhalten',
    customize: 'Anpassen',
    selectYourFavoriteGroup: 'Wähle deine Lieblingsgruppe',
    selectCustom: 'Benutzerdefiniert ',
    setATime: 'Setze eine Zeit fest',
    readyToGoContent: 'Sofort einsatzbereite Inhalte',
    sortBy: 'Sortieren nach',
    type: 'Typ',
    evidenceBasedContentPreparedForYouByOurTeamOfExperts: 'Evidenzbasierte Inhalte von Expertenteams für dich zusammengestellt',
    'Choose from our range of ready-to-go programs designed to support your students and save you time':
        'Wähle aus unserem Angebot an vorgefertigten Programmen, die deine Schüler:innen unterstützen und dir Zeit sparen.',
    'Each of our ready-to-go surveys is designed to help you understand your students better':
        'Unsere vorgefertigten Umfragen sollen dir helfen, deine Schüler:innen besser zu verstehen.',
    'Pick a journal that will keep your students engaged': 'Wähle einen Beitrag, der deine Schüler:innen interessiert.',
    currentlyRunning: 'In Bearbeitung',
    running: 'Läuft',
    paused: 'Pausiert',
    playProgram: 'Programm abspielen',
    pauseProgram: 'Programm pausieren',
    doYouWantToDeleteThisProgram: 'Möchtest du dieses Programm löschen?',
    doYouWantToStartThisProgram: 'Möchtest du dieses Programm starten?',
    doYouWantToStopThisProgram: 'Möchtest du dieses Programm stoppen?',
    postIndividually: 'Individuell posten',
    lastCreated: 'Zuletzt kreieren',
    youMustSelectTargetGroup: 'Du musst eine Zielgruppe auswählen!',
    youMustSelectDaysOfWeek: 'Du musst Wochentage auswählen!',
    Sun: 'So',
    Mon: 'Mo',
    Tue: 'Di',
    Wed: 'Mi',
    Thu: 'Do',
    Fri: 'Fr',
    Sat: 'Sa',
    runIt: 'Durchlaufen lassen',
    classroomTrends: 'Klassenzimmer Trends',
    searchForStudent: 'Nach Schüler/-in suchen',
    searchForTeacher: 'Nach Lehrkraft suchen',
    'all emotions': 'Alle Emotionen',
    uncomfortable: 'Unwohl',
    filterClassroom: 'Klassenzimmer filtern',
    yourIndividualStudentsResponses: 'Individuelle Antworten deiner Schüler:innen',
    uncomfortableEmontionsWithComments: 'Negative Emotionen mit Kommentaren',
    wellbeingOfTeachers: 'Wellbeing der Lehrer/-innen',
    youMustFillData: 'Du musst Daten angeben',
    actionHasBeenAssignedToTeacher: 'Aufgabe wurde der Lehrkraft zugewiesen',
    assignActionFailed: 'Aktion zuweisen fehlgeschlagen',
    sendMessage: 'Nachricht schicken',
    classroomTeacher: 'Klassenlehrer/-in',
    headOfYear: 'Jahrgangsleiter/-in',
    otherTeachers: 'Andere Lehrkräfte',
    typeAnAction: 'Aktion hier eingeben',
    sendPrivateMessageToStudent: 'Sende eine persönliche Nachricht an die Schüler:innen.',
    messageHasBeenSent: 'Nachricht wurde gesendet',
    getDeeperInsights: 'Hier kannst du Trends verfolgen',
    searchQuestion: 'Frage suchen',
    clickToSeeQuestionInDetails: 'Klicke, um die detaillierte Frage zu sehen',
    getDeeperInsightsIntoYourStudentsEmotionalTrends: 'Erhalte tiefere Einblicke in die emotionalen Trends deiner Schüler:innen',
    getInsights: 'Einblicke erhalten',
    totalCommentsLeftUsingHowAreYouToday: 'Gesamtzahl der Kommentare, die unter "Wie geht es dir heute?" hinterlassen wurden',
    basics: 'Basics',
    getBackToMainAnalytics: 'Zurück zu Hauptanalyse',
    searchStudents: 'Schüler/-in suchen',
    lastLogin: 'Letzter Log in',
    neverLoggedIn: 'Noch nie eingeloggt',
    loggedInRecently: 'Kürzlich eingeloggt',
    studentsNotFound: 'Schüler/-in nicht gefunden',
    showMoreStudents: 'Mehr Schüler:innen anzeigen',
    searchTeachers: 'Lehrer/-in suchen',
    position: 'Position',
    teachersNotfound: 'Lehrer/-in nicht gefunden',
    showMoreTeachers: 'Mehr Lehrer/-innen anzeigen',
    studentsWhoDidntRespondToAnyQuestionInPastTwoWeeks: 'Schüler:innen, die keine Fragen in den letzten zwei Wochen beantwortet haben',
    thisCanTakeAwhile: 'Dies kann eine Weile dauern',
    barView: 'Balkenansicht',
    averageResponseDistributionForSelectedPeriod: 'Durchschnittliche Antwortverteilung für den ausgewählten Zeitraum',
    percentageOfResponseDistributionByGender: 'Prozentuale Verteilung der Antworten nach Geschlecht',
    general: 'Allgemein',
    percentageOfResponseDistributionIntotalForSelectedPeriod: 'Prozentsatz der Antwortverteilung insgesamt für den ausgewählten Zeitraum',
    totalCommentsInHowareYouToday: 'Alle Kommentare zu "Wie geht es dir heute?"',
    emotion: 'Emotion',
    noOfCommentsAnsweringHowAreYouToday: 'Anzahl an Kommentaren, die auf "Wie geht es dir heute?" geantwortet haben',
    change: 'Ändern',
    mostCommonReasons: 'Häufigste Gründe',
    thereIsnotAnyConversationYet: 'Es gibt bisher keine Unterhaltungen',
    replyOn: 'Antworten auf',
    myMessage: 'Meine Nachricht',
    'Multiple years': 'Jahrgänge',
    'Multiple classes': 'Klassen',
    addPhotoVideo: 'Foto/Video hinzufügen',
    remove: 'Löschen',
    sorryToHearThatThingsAreWorse: 'Es tut uns leid zu hören, dass es dir schlechter geht.',
    sorryToHearThatThingsAreMuchWorse: 'Es tut uns leid zu hören, dass es dir schlechter geht.',
    goodToHearThingsAreBetter: 'Schön zu hören, dass sich die Lage verbessert hat.',
    greatToHearThingsAreMuchBetter: 'Schön zu hören, dass sich die Lage verbessert hat.',
    'You have no live content': 'Es gibt noch keine Inhalte',
    'Create something and see the results live!': 'Erstelle deinen Inhalt und bekomme live feedback!',
    'Creation shortcuts for you': 'Hier kannst du Inhalte machen',
    'You have no chats': 'Du hast noch keine Chats',
    'Type a question': 'Hier Frage eingeben',
    anonymous_question: 'Anonyme Frage',
    anonymous_survey: 'Anonyme Umfrage',
    anonymous_poll: 'Anonyme Abstimmung',
    'Pick one option': 'Eine Option wählen',
    'Allow more than one answer': 'Mehr als eine Antwort erlauben',
    solutions: 'Lösungswege',
    sos: 'SOS',
    'copy message': 'Nachricht kopieren',
    "List of students who haven't logged in yet and it’s ": 'List von Schülern die sich noch nicht eingeloggt haben',
    'Students login data': 'Schüler Login Daten',
    'Select from favorites': 'Aus Favoriten auswählen',
    Favorite: 'Favorit',
    'Select your favorite group': 'Wähle deine Lieblingsgruppe',
    'New Version is Available': 'Neue Version verfügbar',
    'Delete this note?': 'Diesen Eintrag löschen?',
    'Stop tracking live results for title': 'Für {{title}} keine Ergebnisse mehr specihern',
    'Delete this favorite group?': 'Diesen Favoriten löschen?',
    'Do not agree': 'Ich stimme nicht zu',
    "If you don't agree to Terms and Conditions or Privacy Policy you are not going to be allowed to use the app!": 'Bitte Datenschutzbestimmungen und Privacy Policy zustimmen',
    'You will be logged out': 'Du wirst jetzt ausgeloggt',
    'Delete this feed?': 'Diese Beiträge löschen?',
    'Delete the template for title': 'Vorlage für {{title}}  löschen',
    'No one yet': 'Niemand bisher',
    'Seen by:': 'Gesehen von:',
    Copied: 'Kopiert',
    'Action taken': 'Fall in Bearbeitung',
    'Write your thoughts here': 'Hier kannst du deine Gedanken dazu aufschreiben',
    'Describe how will you take action about this student': 'Was genau hast du geplant?',
    'I will take action': 'Ich werde mich kümmern',
    'Ask your manager to assign you to class.': 'Bitte an Admin wenden, um eine Klasse zugeordnet zu bekommen',
    'You have no data about your classroom': 'Es gibt noch keine Daten aus deiner Klasse',
    'Terms and Conditions and Privacy Policy': 'Bedingungen, Richtlinien und Privatsphäre',
    "I confirm that I read and agree to Upstrive's":
        'Ich bestätige, dass ich die Datenschutzbestimmungen und die Bedingungen und Richtlinien von Upstrive gelesen habe und bestätige diese.',
    'Terms and Conditions': 'Bedingungen und Richtlinien',
    'I do not agree': 'Ich stimmt nicht zu',
    'New survey!': 'Neue Umfrage!',
    youHaveASurveyAbout: 'Du hast eine Umfrage zu ',
    voluntary: 'freiwillig',
    mandatory: 'Pflicht',
    'Language is changed': 'Sprache wurde geändert',
    'Your counseling list is empty, start with adding a new counseling profile for one of your students':
        'Die Liste ist leer. Beginne eine neue, indem du ein Profil für einen deiner Schüler erstellst.',
    'Reminder for today': 'Erinnerung für heute',
    'Track Counseling': 'Beratung nachverfolgen',
    'Congrats, everything is done for now!': 'Glückwunsch, du hast alles geschafft!',
    'Wait for new tasks...': 'Neue Aufgaben kommen sicher bald… ',
    'Manage running programs': 'Laufende Programme verwalten',
    'This tool helps you to control all running programs and track their influence to students':
        'Dieses Tool hilft dir, alle laufenden Programme zu verwalten und ihren Einfluss auf die Schüler:innen zu beobachten',
    'Your running program list is empty, start by adding one from the list of programs':
        'Deine Liste laufender Programme ist leer. Starte ein Neues, indem du eines von der Programmliste auswählst',
    'Run program': 'Programm starten',
    "This tool helps you to schedule whole program once so you don't need to check it all the time":
        'Dieses Tool hilft dir ein Programm so zu erstellen, dass es selbstständig läuft',
    'Target group:': 'Zielgruppe',
    'Start date:': 'Anfangsdatum:',
    'Select days:': 'Tage wählen:',
    'Pick time:': 'Zeit wählen:',
    'Current programs:': 'Aktuelle Programme:',
    Running: 'Läuft',
    'Show more programs': 'Weitere Programme zeigen',
    'Create a survey': 'Umfragen erstellen',
    'Type a survey title': 'Umfragenüberschrift erstellen',
    'add a survey description': 'Umfragenbeschreibung hinzufügen',
    'enter a section title here': 'Abschnittstitel hinzufügen',
    Section: 'Abschnitt',
    Sections: 'Abschnitte',
    'enter a section description here': 'Abschnittsbeschreibung hinzufügen',
    'Enter a question here': 'Frage hinzufügen',
    'Add section': 'Kategorie hinzufügen',
    'Delete survey': 'Umfrage löschen',
    'Save Survey': 'Umfrage speichern',
    'Edit Survey': 'Umfrage bearbeiten',
    'This tool helps you to run a survey for your students': 'Dieses Tool hilft dir eine Umfrage für deine Schüler zu erstellen',
    'Configure survey': 'Umfrage konfigurieren',
    'Easily manage your students and teachers, using separate functions': 'Hier kannst du Schülern und Lehrern einfach verwalten',
    'Login info': 'Login Information',
    'Class info': 'Klassen Information',
    Download: 'Download',
    'Export report': 'Bericht exportieren',
    'Enter your note here': 'Notiz hinzufügen',
    'Add reminder': 'Erinnerung hinzuffügen',
    'Show more surveys': 'mehr Umfragen zeigen',
    'Open survey results': 'Umfragenergebnisse öffnen',
    'Take it now': 'Jetzt Umfrage starten',
    'Take it later': 'Später',
    Category: 'Kategorie',
    'Select all': 'Wählen Sie Alle',
    'Survey results': 'Umfrageergebnisse',
    'We hope you’ve had a good day!': 'Wir hoffen, Du hattest einen guten Tag!',
    'Save your favorite group': 'Speichern Sie Ihre Lieblingsgruppe',
    anonymous_journal: 'Anonymes Tagebuch',
    'Welcome back': 'Willkommen zurück!',
    'Here’s what happened while you were away': 'Hier siehst du was passiert ist während du weg warst',
    Overview: 'Übersicht',
    Posts: 'Posts',
    'Action Required': 'Maßnahmen erforderlich',
    'Your Classrooms': 'Dein Klassenzimmer',
    'Engagement Statistics': 'Engagement-Statistik',
    '% of responses on active polls & questions': '% der Antworten auf aktive Umfragen',
    '% of students using "How are you?" at least once per week': '% deiner Schüler:innen benutzen "Wie geht es dir?" mindestens einmal pro Woche',
    'Edit Group': 'Gruppe bearbeiten',
    'Create Group': 'Gruppe erstellen',
    'Monitoring group': 'Gruppe kontrollieren',
    'You have to select at least one emotion': 'Du musst mindestens eine Emotion auswählen',
    'Create Group and Apply filter': 'Gruppe erstellen',
    'Edit Group and Apply filter': 'Kontrollgruppe aktualisieren',
    'Name a new group type here': 'Nenne hier eine neue Gruppenart',
    'Created new monitoring group!': 'Neue Kontrollgruppe erstellen!',
    'Updated monitoring group!': 'Kontrollgruppe aktualisieren',
    'Search results': 'Antworten durchsuchen',
    Filter: 'Filter',
    'Filter results': 'Resultate filtern',
    'Filter posts': 'Posts filtern',
    'Setup your filter': 'Filter erstellen',
    'Filter by dates': 'Nach Datum filtern',
    'Select what to display': 'Auswählen, was angezeigt werden soll',
    'Display All': 'Alle anzeigen',
    From: 'Von',
    To: 'Bis',
    Date: 'Datum',
    Target: 'Zielgruppe',
    By: 'Von',
    Time: 'Zeit',
    'Delete this question?': 'Diese Frage löschen?',
    'Delete this poll?': 'Diese Abstimmung löschen?',
    'Delete this survey?': 'Diese Umfrage löschen?',
    'Delete this post?': 'Diesen Beitrag löschen?',
    'Delete this program?': 'Dieses Programm löschen?',
    'Open link': 'Link öffnen',
    'Action needed': 'Handlungsbedarf',
    'Select emotion that fits your mood': 'Wähle eine Emotion, die zu deiner Stimmung passt',
    "What's the main reason?": 'Was ist der Hauptgrund hierfür?',
    'Pick up to 3': 'Wähle bis zu 3',
    myself: 'Ich',
    family: 'Familie',
    friends: 'Freunde',
    'social media': 'Soziale Medien',
    wellbeing: 'Wellbeing',
    health: 'Gesundheit',
    school: 'Schule',
    achievement: 'Erfolge',
    sleep: 'Schlaf',
    Myself: 'Ich',
    Family: 'Familie',
    Friends: 'Freunde',
    'Social media': 'Soziale Medien',
    Wellbeing: 'Wellbeing',
    Health: 'Gesundheit',
    School: 'Schule',
    Achievement: 'Erfolge',
    Sleep: 'Schlaf',
    'How do you feel compared to last time you logged in?': 'Wie fühlst du dich im Vergleich zum letzten Mal als du dich eingeloggt hast?',
    'Do you think things are same for any reason in particular?': 'Gibt es einen bestimmten Grund, warum alles wie beim letzten Mal ist?',
    'Type name for your note here': 'Gebe hier einen Namen für deine Notiz an ',
    Chat: 'Chat',
    'Catch-up': 'Catch-up',
    Menu: 'Menü',
    'Wellbeing Tracker': 'Wellbeing Tracker',
    Day: 'Tag',
    'Choose your answer': 'Wähle deine Antwort',
    '1st': '1.',
    '2nd': '2.',
    '3rd': '3.',
    '4th': '4.',
    '5th': '5.',
    '6th': '6.',
    '7th': '7.',
    '8th': '8.',
    '9th': '9.',
    '10th': '10.',
    History: 'Historie',
    'My Classroom': 'Mein Klassenzimmer',
    'Actions required': 'Maßnahmen erforderlich',
    'Comments for review': 'Kommentare zur Überprüfung',
    'Actions assigned to me': 'Mir zugewiesene Maßnahmen',
    'Student chat': 'Schüler/-innen Chat',
    'Select one option': 'Wähle eine Option',
    Finish: 'Beenden',
    Next: 'Nächste',
    Uncomfortable: 'Unwohl',
    'Classroom Trends': 'Klassenzimmer Trends',
    'Filter Emotions': 'Emotionen filtern',
    Comments: 'Kommentare',
    'Filter Classroom': 'Klassenzimmer filtern',
    'No comments': 'Keine Kommentare',
    'Seen by': 'Gesehen von',
    'Assigned to': 'Zugewiesen zu',
    'Send Private message to student': 'Private Nachricht an einen Schüler/ eine Schülerin senden',
    'Write personal message for the student here': 'Schreibe hier eine private Nachricht für einen Schüler/ eine Schülerin',
    'Select teacher': 'Lehrer:in auswählen',
    'Assign to teacher': 'Lehrkraft zuweisen',
    'Classroom Teacher': 'Klassenlehrer/-in',
    'Head of Year': 'Jahrgangsleiter/-in',
    'Other Teachers': 'Andere Lehrkräfte',
    'Assign to this teacher': 'Dieser Lehrkraft zuweisen',
    'Type here': 'Hier eingeben ',
    'Message has been sent to student!': 'Nachricht wurde an den Schüler/ die Schülerin verschickt',
    'Check for any student comments that may have been overlooked': 'Prüfe, ob du Kommentare von Schüler/-innen übersehen hast',
    'My message': 'Meine Nachricht',
    Unseen: 'Ungelesen',
    'No unseen replies left': 'Keine ungelesenen Antworten',
    'Congratulations!': 'Herzlichen Glückwunsch!',
    'wellbeing tracker': 'Wellbeing Tracker',
    'Mark as seen': 'Als gesehen markieren',
    'Comment has been seen!': 'Kommentar wurde gesehen!',
    'You can press yellow button and create a new Wellbeing profile': 'Du kannst den gelben Button wählen, um ein neues Wellbeing Profil zu erstellen',
    'Your list is empty': 'Deine Liste ist leer',
    'You are not in charge of this student so your messages will be forwarded to school admin or counselor':
        'Du bist nicht für diesen Schüler/ diese Schülerin verantwortlich. Deine Nachricht wird zum Schuladministrator weitergeleitet.',
    'Log comment': 'Kommentar protokollieren',
    'Click to copy email': 'Klicken, um E-mail zu kopieren',
    '% of responses on active polls, questions': '% von Antworten auf aktive Umfragen/Fragen',
    'Date of Birth': 'Geburtstag',
    'Create your own': 'Inhalte selbst erstellen',
    'Ready-to-go': 'Ready-to-go',
    'Feed Posts': 'Feed Post',
    'You are not allowed to create content': 'Du bist nicht dazu berechtigt Inhalte zu erstellen',
    'Upcoming Content': 'Zukünftige Events',
    'Pending Content': 'Ausstehender Inhalt',
    'Create a question': 'Frage erstellen',
    'Headline for question': 'Überschrift der Frage',
    'Headline for poll': 'Überschrift  der Abstimmung',
    Headline: 'Überschrift',
    'Supportive Text': 'Unterstützender Text',
    'Select one item from the list': 'Wähle eine Möglichkeit aus der Liste',
    'Pick one or more options': 'Wähle eine oder mehrere Optionen',
    'Select one or more items from the list': 'Wähle eine oder mehrere Optionen aus der Liste',
    'Enter Link (optional)': 'Link hinzufügen (optional)',
    'Enter any url here': 'Gebe hier eine URL ein',
    AddVideoPhoto: 'Video/Foto hinzufügen',
    'The maximum image size for download is 1400px x 1400px': 'Die maximale Größe für Bilder beträgt 1400px x 1400px',
    'Media file is too big. Try smaller one': 'Mediendatei ist zu groß. Versuche es mit einer kleineren…',
    'Add to Wellbeing Tracker': 'Zum Wellbeing Tracker hinzufügen',
    'Target group is not selected': 'Zielgruppe wurde nicht ausgewählt',
    Option: 'Option',
    'Write option': 'Option schreiben',
    here: 'Hier ',
    'Use Template': 'Vorlage verwenden',
    "You don't have any incoming content": 'Du hast keine externen Beiträge erhalten',
    'Run a journal': 'Tagebuch starten',
    'View Details': 'Details ansehen',
    'Run it': 'Durchlaufen lassen',
    'Run a survey': 'Umfrage starten',
    'Survey needs to be reviewed by the school admin': 'Umfrage muss durch den Schuladministrator geprüft werden',
    'Survey has been created': 'Umfrage wurde erstellt',
    'Select a category': 'Wähle eine Kategorie',
    Favorites: 'Favoriten',
    Customize: 'Anpassen',
    OK: 'OK',
    'Post individual': 'Individueller Beitrag',
    'Select specific teachers you would like to get information from': 'Wähle Lehrkräfte von denen du gerne Informationen erhalten würdest',
    'Select specific year groups to gather more information from': 'Wähle eine Schulstufe aus, um über sie weitere Informationen zu erhalten',
    'Select specific classes to gather more information from': 'Wähle Klassen aus, um über sie weitere Informationen zu erhalten',
    'Create your own customized group to gather information from': 'Erstelle Deine eigene Gruppe, um über sie weitere Informationen zu erhalten',
    'Add to favorites': 'Zu Favoriten hinzufügen',
    feelingSameQuestion: 'Was kannst du jetzt tun, um die Lage zu verbessern?',
    good: 'gut',
    numb: 'taub',
    worried: 'besorgt',
    read: 'lesen',
    received: 'Erhalten',
    experienceIt: '% erleben es',
    anonymousQuestion: 'Anonyme Frage',
    openQuestion: 'Frage öffnen',
    Attention: 'Achtung',
    toEnsureYourPrivacyThisKeyIsNotRecoverableAllYourNotesWillBeLostIfYouForgetThisKey:
        'Um deine Privatsphäre zu schützen, ist dieser Schlüssel nicht wiederherstellbar. Wenn du diesen Schlüssel vergisst, gehen alle deine Notizen verloren!',
    anonymousPoll: 'Anonyme Abstimmung',
    Previous: 'Vorher',
    'At least 8 characters': 'Mindestens 8 Zeichen',
    'Your results are saved!': 'Deine Ergebnisse wurden gespeichert!',
    rememberMe: 'Angemeldet bleiben',
    instructionVideo: 'Erklärungsvideo',
    yourTasks: 'Deine Aufgaben',
    activitiesForCompletion: 'Ausstehende Aufgaben',
    oopsThereSeemsToBeAnIssueWithConnection: 'Es scheint ein Problem mit deiner Internetverbindung zu geben',
    pleaseTryAgainInAFewMinutestOrContactUpstriveSupport: 'Bitte versuche es erneut in ein paar Minuten oder kontaktiere Upstrive Support',
    loadingMoreFeeds: 'Mehr Inhalte werden geladen',
    openJournal: 'Vertrauliches Tagebuch',
    selectEmotionThatBestDescribesYourMoodToday: 'Wähle eine Emotion, die deine heutige Stimmung am besten beschreibt',
    yourBrowserDoesNotSupportHTMLVideo: 'Dein Browser unterstützt kein HTML-Video',
    whatIsTheMainReason: 'Was ist der Hauptgrund hierfür?',
    pickUpTo3: 'Wähle bis zu 3',
    typeAnyAdditionalTextHere: 'Zusätzlichen Text hier eingeben',
    howDoYouFeelComparedToLastTimeYouLoggedIn: 'Wie fühlst du dich im Vergleich zu dem Zeitpunkt, an dem du dich das letzte Mal eingeloggt hast?',
    iDontWantToThinkAboutItNow: 'Ich möchte gerade nicht darüber nachdenken',
    stepBack: 'Zurückgehen',
    whatCouldYouDoToImproveThingsRightNow: 'Was könntest du gerade tun, um die Dinge zu verbessern?',
    selectOneOption: 'Wähle eine Option',
    youHaveMissedThisQuestion: 'Du hast die Frage ausgelassen',
    finish: 'Beenden',
    nextSection: 'Nächster Teil',
    yourAnswersAreSaved: 'Deine Antworten wurden gespeichert!',
    typeYourAnswerHere: 'Gebe deine Antwort hier ein',
    iHaveAnIssueRelatedTo: 'Ich habe ein Problem mit....',
    sorryYourSchoolRestrictedAccessToThisModule: 'Leider hat deine Schule den Zugang zu diesem Modul eingeschränkt.',
    exploreThingsYouCanDoRightNow: 'Was du tun kannst - schnell und einfach',
    seeHowOtherStudentsHandleThis: 'Schaue dir an, wie andere Schüler/-innen damit umgehen ',
    connectWithTheConselor: 'Kontakt zur Beratungslehrkraft herstellen',
    quickTips: 'Schnelle Tipps',
    howToDealWithThisProblem: 'Wie du mit dem Problem umgehen kannst',
    thingsYouCanDoRightNow: 'Dinge, die du gerade tun kannst',
    yesThanks: 'Ja, danke!',
    notReally: 'Nicht wirklich',
    expertRecommendation: 'Experten Empfehlung',
    wasThisSolutionHelpful: 'War die Lösung hilfreich?',
    send: 'Senden',
    topic: 'Thema',
    'I Care / I Listen': 'SOS',
    privateNotes: 'Private Notizen',
    yourSecretKeyIsSaved: 'Dein Passwort wurde gespeichert!',
    changeSecurityKey: 'Geheimen Schlüssel ändern',
    passwordSetup: 'Passwort wählen',
    atLeast8Caracters: 'Mindestens 8 Zeichen',
    mobileAndDesktopStudentVersion: 'Mobile und Desktop - Schüler/-innen Version.mp4',
    weHopeYouHaveAGoodDay: 'Wir wünschen dir einen schönen Tag!',
    whatAre3ThingsThatAreABitChallengingAtTheMoment: 'Welche drei Dinge sind momentan etwas herausfordernd?',
    whatsJustOneThingYouWillDoDifferentlyTomorrow: 'Nenne eine Sache, die du morgen anders machen wirst ',
    typeOneThingHere: 'Nenne eine Sache',
    'Type 1st thing here': 'Schreibe die erste Sache hier',
    noteHasBeenDeleted: 'Die Notiz wurde gelöscht. ',
    returnBack: 'Kehre zurück',
    yourResultsAreSaved: 'Deine Ergebnisse wurden gespeichert!',
    majorUpdate: 'Wichtige Aktualisierung',
    whatsNew: 'Was gibt es Neues?',
    sameGreatAppFreshNewLook: 'Die gleiche tolle App mit neuem Aussehen und neuen Funktionen!',
    next: 'Nächste',
    closePopup: 'Pop-up schließen',
    Browse: 'Suchen/Stöbern',
    '% of students using Upstrive (per week, any function)': '% aller Schüler/-innen nutzen Upstrive wöchentlich',
    '% of teachers using Upstrive (per week, any function)': '% der Lehrkräfte haben sich angemeldet',
    '% this week': '% diese Woche',
    'Click on emotion to go into the classroom details': 'Klicken Sie auf "Emotion", um zu den Details des Klassenzimmers zu gelangen',
    'Type name in the field below': 'Geben Sie den Namen in das Feld darunter ein',
    'Track student task responses': 'Hier siehst du die Antworten der Schüler:innen auf die Abstimmungen und Umfragen',
    'Full name': 'Full name',
    "You can't delete yourself!": 'Du kannst dich nicht selbst löschen!',
    'Choose from our range of ready-to-go programs designed to support your students and save you times now':
        'Aus einer Auswahl fertiger Programme wählen, um deine Schüler zu unterstützen und um Zeit zu sparen',
    '% of students using “How are you?” at least once per week': '% der Schüler/-innen haben sich eingeloggt',
    feelingMuchWorseQuestion: 'Es tut uns leid zu hören, dass es dir schlechter geht. Welche von den Vorschlägen unten kann dir jetzt weiterhelfen?',
    feelingBetterQuestion: 'Schön zu hören, dass sich die Lage verbessert hat. Hast du Ideen wie du sie vielleicht noch besser machen könntest? ',
    'Teacher only': 'nur Lehrer',
    'Your tasks': 'Deine Aufgaben',
    'Tasks archive': 'Aufgaben-Archiv',
    'You have completed all your tasks': 'Du hast alle Aufgaben erledigt',
    'I have an issue related to': 'Ich habe ein Problem in Bezug auf',
    'Choose topic': 'Thema auswählen',
    'Sorry, your school restricted access to this module': 'Entschuldigung, deine Schule hat den Zugriff auf dieses Modul eingeschränkt',
    'Assignment for': 'Auftrag für',
    'Create Wellbeing profile': 'Wellbeing Profil erstellen',
    Home: 'Startseite',
    'Send message to all students': 'Nachricht an alle Schüler senden',
    'Send message to all teachers': 'Nachricht an alle Lehrer senden',
    'Finish later': 'Später beenden',
    'This day is locked!': 'Dieser Tag ist abgeschlossen!',
    'General Wellbeing': 'Allgemeines Wellbeing',
    'This is a great place to start if you’re looking for some general wellbeing content before diving into some of the more specific topics.':
        'Dies ist ein großartiger Ausgangspunkt, wenn du nach allgemeinem Wellbeing-Inhalt suchst, bevor du dich mit spezifischeren Themen beschäftigst.',
    'Personal Wellbeing': 'Persönliches Wellbeing',
    'Here you’ll find more personal wellbeing content designed to help you and your students learn more about specific challenges and ways to overcome them.':
        'Hier findest du mehr Inhalte zum persönlichen Wellbeing, die darauf abzielen, dir und deinen Schülern zu helfen, spezifische Herausforderungen zu verstehen und zu überwinden.',
    'If it’s a school-related topic such as getting organised, excelling in exams, or being productive, it’s right here for you!':
        'Wenn es um schulbezogene Themen wie Organisation, Prüfungserfolg oder Produktivität geht, findest du hier alles, was du brauchst!',
    'Stress Management': 'Stressmanagement',
    'Find out more about your students’ & colleagues’ experiences of stress with a survey and support them with a range of stress management tools.':
        'Finde mehr über die Erfahrungen deiner Schüler & Kollegen mit Stress heraus, indem du eine Umfrage durchführst, und unterstütze sie mit einer Reihe von Stressmanagement-Tools.',
    'Self-management': 'Selbstmanagement',
    'Retrieving data. Wait a few seconds and try to cut or copy again.':
        'Daten werden abgerufen. Bitte warte einige Sekunden und versuche dann erneut zu schneiden oder zu kopieren',
    SEL: 'SEL',
    'Our range of social and emotional learning (SEL) content is all designed to help you & your students enhance self-awareness and develop greater self-management skills.':
        'Unsere Palette an Inhalten zum sozialen und emotionalen Lernen (SEL) soll dir und deinen Schülern dabei helfen, das Selbstbewusstsein zu stärken und bessere Selbstmanagement-Fähigkeiten zu entwickeln.',
    mood: 'Stimmung',
    Default: 'Default',
    '% of all students are with selected type of emotions': '% aller Schüler:innen haben bestimmte Emotionen.',
    'It is 71% less then on previous week': 'Es ist {{num}}% weniger als in der Vorwoche',
    'It is 71% more then on previous week': 'Es ist {{num}}% mehr als in der Vorwoche',
    'Cannot create anonymous survey for 1 user': 'Es ist nicht möglich, eine anonyme Umfrage für einen einzelnen Benutzer zu erstellen.',
    'Cannot create anonymous poll for 1 user': 'Es ist nicht möglich, eine anonyme Abstimmung für einen einzelnen Benutzer zu erstellen.',
    'Cannot create anonymous poll for 2 users': 'Es ist nicht möglich, eine anonyme Abstimmung für nur zwei Benutzer zu erstellen.',
    'Release survey by days': 'Die Umfrage kann nach Tagen freigegeben werden.',
    "This tool helps you to schedule whole survey once so you don't need to check it all the time":
        'Dieses Tool hilft dir dabei, die gesamte Umfrage auf einmal zu planen, sodass du sie nicht ständig überwachen musst.',
    'Please select file': 'Bitte Datei auswählen',
    'Schedule Survey': 'Umfrage planen',
    'No items found': 'Es wurden keine Elemente gefunden.',
    completed: 'abgeschlossen',
    filterResults: 'Resultate filtern',
    'Add student': 'Schüler/-in hinzufügen',
    'Select surveys': 'Umfragen auswählen',
    'Type of class to create': 'Typ der zu erstellenden Klasse',
    Regular: 'Regulär',
    Primary: 'Primär',
    'Primary class': 'Primärklasse',
    Avatar: 'Avatar',
    'Not Setuped': 'Nicht eingerichtet',
    'Transfer to another class': 'In eine andere Klasse versetzen',
    'You must select class': 'Sie müssen eine Klasse auswählen',
    'Current class': 'Aktuelle Klasse',
    'Select new class': 'Neue Klasse auswählen',
    'Select class': 'Klasse auswählen',
    'Change avatar': 'Avatar ändern',
    'Edit Student': 'Schüler bearbeiten',
    'Step 1/2': 'Schritt 1/2',
    'Step 2/2': 'Schritt 2/2',
    'Choose Gender': 'Geschlecht auswählen',
    'Choose animal': 'Tier auswählen',
    'Create Student': 'Schüler erstellen',
    Available: 'Verfügbar',
    Taken: 'Belegt',
    'If you will choose already taken character it will auto unpin from existing child':
        'Wenn Sie ein bereits belegtes Charakterbild auswählen, wird es automatisch von einem vorhandenen Kind entfernt.',
    'Choose later': 'Zu einem späteren Zeitpunkt auswählen',
    'Save with selected avatar': 'Mit ausgewähltem Avatar speichern',
    'Are you sure you want to delete class?': 'Sind Sie sicher, dass Sie die Klasse löschen möchten?',
    'All Student in this class will be deleted': 'Alle Schüler dieser Klasse werden gelöscht',
    'No, cancel': 'Nein, abbrechen',
    'Yes, Delete': 'Ja, löschen',
    'Class successfully deleted': 'Klasse erfolgreich gelöscht',
    Success: 'Erfolg',
    'Transfer to another class successfully finished': 'Erfolgreicher Transfer in eine andere Klasse abgeschlossen',
    'Old class': 'Alte Klasse',
    Display: 'Anzeige',
    'Your Primary Classes': 'Ihre Primärklassen',
    'The new password has been sent!': 'Das neue Passwort wurde gesendet!',
    'Password delivery failed!': 'Die Übermittlung des Passworts ist fehlgeschlagen!',
    'File has been removed': 'Datei wurde entfernt',
    'Preset Ranges': 'Vordefinierte Zeiträume',
    'Last Month': 'Letzter Monat',
    'Last Quarter': 'Leztes Quartal',
    'Last Year': 'Letztes Jahr',
    'Data is saved': 'Daten werden gespeichert',
    'Allocation of answers from students who answered on “How are you Today?”': 'Anzahl der Antworten von Schülern, die auf die Frage "Wie geht es Dir heute?" geantwortet haben',
    'New password has already been generated today for this user. Do you want to generate it again?':
        'Ein neues Passwort wurde heute bereits für diesen Benutzer generiert. Möchten Sie es erneut generieren?',
    'Not logged in': 'Nicht eingeloggt',
    'Logged in': 'Eingeloggt',
    'Current Weekly Engagement Statistics': 'Aktuelle Statistiken zum wöchentlichen Engagement',
    'Student logins': 'Schüler:innen Logins',
    'Student check in': 'Einchecken der Studenten',
    'Student engagement with content': 'Schüler:innen Interaktion mit Inhalten',
    'Teacher logins': 'Lehrkräfte Logins',
    'This percentage reflects the number of teacher logins for this week': 'Dieser Prozentsatz spiegelt die Anzahl der Anmeldungen von Lehrern für diese Woche wider',
    'This percentage reflects  students interacting with app content beyond check-ins.':
        'Dieser Prozentsatz spiegelt die Interaktion der Schüler mit den App-Inhalten über das Einchecken hinaus wider.',
    'This percentage reflects students who have both logged in and completed a check-in for the week':
        'Dieser Prozentsatz spiegelt die Schüler wider, die sich sowohl angemeldet als auch einen Check-in für die Woche durchgeführt haben.',
    'This statistic reflects the number of student logins for this week': 'Diese Statistik zeigt die Anzahl der Anmeldungen von Schülern in dieser Woche',
    'Use this pre-set Sample Group to monitor the uncomfortable emotions your students might log.':
        'Verwenden Sie diese voreingestellte Mustergruppe, um die unangenehmen Emotionen zu beobachten, die Ihre Schüler aufzeichnen könnten.',
    'Sample Group': 'Test Gruppe',
    'Comfortable Emotions': 'Angenehme Emotionen',
    'Uncomfortable Emotions': 'Unangenehme Emotionen',
    clickTheButtonsOnTheRightToAccessSpecificAnalyticsForThoseTimeframes: 'Klicke auf die Schaltflächen rechts, um spezifische Analysen für diese Zeiträume aufzurufen',
    effortlesslyMonitorYourStudentsEmotionalExperiencesByCreatingYourOwnCustomisedGroupsHere:
        'Beobachte mühelos die emotionalen Erfahrungen deiner Schüler:innen, indem du hier deine eigenen Gruppen erstellst.',
    '% of students responding to "How are you today? at least once a week.': '% der Schüler, die mindestens einmal pro Woche auf die Frage "Wie geht es Dir heute?"',
    'No. of comments left in response to "How are you today?': 'Anzahl der hinterlassenen Kommentare auf die Frage "Wie geht es Dir heute?" ',
    'Emotion distribution for selected period': 'Gefühlsverteilung für den ausgewählten Zeitraum',
    'No. of comments left in response to "How are you today?"': 'Anzahl der hinterlassenen Kommentare auf die Frage "Wie geht es Dir heute?" ',
    'No. of comments responding to, “How are you today?”': 'Anzahl der Kommentare auf die Frage "Wie geht es Dir heute?"',
    'More details': 'Mehr Details',
    'Overall engagement': 'Allgemeine Beteiligung ',
    'Engagement with emotions': 'Interaktion mit Emotionen',
    'Total emotions submitted': 'Gesamtzahl Emotionen',
    'Total number of emotions submitted in the time frame': 'Gesamtzahl der in dem Zeitraum eingereichten Emotionen',
    'Relative change to the same selected previous period': 'Relative Veränderung im Vergleich zum gleichen ausgewählten Vorzeitraum',
    'No data from the previous period to compare': 'Keine Daten aus dem Vorzeitraum zum Vergleich',
    'No change compared to the previous period': 'Keine Veränderung gegenüber dem Vorzeitraum',
    'Percent of students that submitted an emotion in the selected time frame': 'Prozentsatz der Studenten, die im ausgewählten Zeitraum eine Emotion eingereicht haben',
    'Percentage of students that used Upstrive in the period (any function, just opened it)':
        'Prozentsatz der Schüler, die Upstrive in diesem Zeitraum genutzt haben (jede Funktion, nur geöffnet)',
    'Percentage of students who have experienced these emotions in selected period': 'Prozentsatz der Schüler, die in dem ausgewählten Zeitraum diese Emotionen erlebt haben',
    'Percentage of teachers who have registered to the app': 'Prozentsatz der Lehrer, die sich für die App registriert haben',
    'Percentage of students who have registered to the app': 'Prozentsatz der Studenten, die sich für die App registriert haben',
    'Percentage of students engaging with content this week': 'Prozentsatz der Schüler, die sich in dieser Woche mit dem Inhalt beschäftigt haben',
    'Percentage of student check-ins this week': 'Prozentsatz der Schüler-Check-ins in dieser Woche',
    'Percentage of student logins this week': 'Prozentsatz der Anmeldungen von Schülern in dieser Woche',
    'Percentage of teacher logins this week': 'Prozentsatz der Lehreranmeldungen in dieser Woche',
    'Time period': 'Zeitspanne',
    'Time frame': 'Zeitrahmen',
    'Add a new trend': 'Einen neuen Trend hinzufügen',
    'Engagement with content': 'Beschäftigung mit Inhalten',
    'Percentage of students that submitted an emotion in the selected time frame': 'Prozentsatz der Studenten, die im ausgewählten Zeitraum eine Emotion eingereicht haben',
    'Percentage of students engaging with content in the selected time frame': 'Prozentsatz der Schüler, die sich im ausgewählten Zeitraum mit dem Inhalt beschäftigt haben',
    'General Engagement': 'Allgemeines Engagement',
    Registration: 'Anmeldung',
    'Percentage of students in your group who have registered in Upstrive': 'Prozentsatz der Schüler in Ihrer Gruppe, die sich bei Upstrive angemeldet haben',
    'Percentage of teachers in your group who have registered in Upstrive': 'Prozentsatz der Lehrkräfte in Ihrer Gruppe, die sich bei Upstrive registriert haben',
    'Remove from trends': 'Aus Trends entfernen',
    'Student engagement with emotions': 'Schüler:innen Engagement mit Emotionen',
    'No. of emotions': 'Anzahl an Emotionen',
    'Create & Manage Reports': 'Berichte erstellen und verwalten',
    'Create report': 'Erstelle Bericht',
    'Latest reports': 'Neueste Berichte',
    'View More': 'Mehr sehen',
    'Return to Analytics': 'Zurück zur Analyse',
    'Output fields': 'Ausgangsfeld',
    'Target users': 'Zielgruppe',
    'Create Reports': 'Erstelle Berichte',
    'Report format': 'Bericht Format',
    Raw: 'Rohdaten',
    'Select report dates': 'Wähle Berichtsdaten aus',
    'Remember to set up filters to get started!': 'Denke daran, Filter einzurichten, um loszulegen!',
    'Last step': 'Letzter Schritt',
    'Setup report name as your last step': 'Richte im letzten Schritt einen Berichtnamen ein',
    'Report name': 'Berichtnamen',
    'Enter file name': 'Dateinamen eingeben',
    'You will be notified once your report is ready': 'Sie werden benachrichtigt, sobald Ihr Bericht bereit ist.',
    'Report-2024-01-29': 'Report-2024-01-29',
    'Welcome! Create your first report here': 'Willkommen! Erstelle deinen ersten Bericht. ',
    'Your opinion matters to us!': 'Deine Meinung ist uns wichtig!',
    'Your feedback helps us to improve. If you find our app helpful, please consider rating it.':
        'Dein Feedback trägt zur Verbesserung bei. Wenn du unsere App hilfreich findest, bitte bewerte sie.',
    'Share your feedback': 'Teil uns deine Meinung mit. ',
    'Leave your feedback': 'Teil uns deine Meinung mit. ',
    'Type your feedback here': 'Teile dein Feedback hier.',
    'Select time range': 'Zeitraum auswählen',
    'Number of student who answered "How are you today?" on this date': 'Anzahl der Schüler:innen, die an diesem Tag "Wie geht es dir" beantwortet haben',
    'From creating confidence to goal setting, you’ll find a great range of skill-based surveys, programs, and journals here.':
        'Von "Selbstvertrauen gewinnen" bis "Ziele erreichen", hier findest du alles was du brauchst: Kurse, Umfragen und Tagebücher',
    'Track trends': 'Trends beobachten',

    'Content has been removed from trends': 'Der Inhalt wurde aus den Trends entfernt',
    'In process': 'In Arbeit',
    'Report failed': 'Fehlgeschlagen',
    'Download report as {{format}}': 'Bericht als {{format}} herunterladen',
    'Report is not available for download': 'Bericht ist nicht zum Download verfügbar',
    'End date:': 'End Datum:',

    'Total response percentage': 'Gesamt Antworten',
    'You are going to generate new password for this student?': 'Möchtest du ein neues Passwort fur diese(n) Schüler:in generieren?',
    'New password has already been generated today for this user! Do you want to generate it again?':
        'Es wurde bereits ein Passwort für diese(n) Schüler:in generiert, möchtest du totzdem ein neues generieren?',
    'New class': 'Neue Klasse',
    'Day review': 'Mein Tag',
    'Seen 6 days ago': 'Vor {{time}} gesehen worden',
    'Left 6 days ago': 'Vor {{time}}',
    'Thank you for helping us to make Upstrive better.': 'Danke, dass du uns hilfst Upstrive besser zu machen',

    month: 'Monat',
    months: 'Monaten',
    hour: 'Stunde',
    hours: 'Stunden',
    minute: 'Minute',
    minutes: 'Minuten',
    seconds: 'Sekunden',
    'No reports have been created yet': 'Es wurden noch keine Berichte erstellt',
    Grade: 'Jahrgang',
    'Feedback date': 'Feedback-Datum',
    "Student's emotion": 'Emotionen des Studenten',
    "Student's commnet": 'Comment',
    Reasons: 'Gründe',
    reasons: 'Gründe',
    "Teachers' action": 'Lehreraktion',
    'Number of students that left a comment combined with uncomfortable emotion':
        'Anzahl der Studierenden, die einen Kommentar zusammen mit einem unangenehmen Gefühl hinterlassen haben.',
    '7d': '7t',
    '1m': '1m',
    '3m': '3m',
    '1y': '1j',
    'Percentage of students that submitted an emotion this week': 'Anteil der Schüler:innen, die diese Woche eine Emotion eingereicht haben',
    'Write your personal notes here': 'Hier kannst du Notizen machen',
    'Thank you!': 'Vielen Dank!',
    'Tell us how we can improve Upstrive in the box below': 'Teile uns im unten stehenden Feld mit, wie wir Upstrive verbessern können',
    'Reminder has been deleted!': 'Erinnerung wurde gelöscht!',
    'Program has been deleted!': 'Das Programm wurde gelöscht!',
    'New password is generated': 'Ein neues Passwort wurde generiert.',
    "Student's feedback": 'Feedback der Studierenden',
    "Student's comment": 'Kommentare des Schülers',
    'You must select at least one option': 'Sie müssen mindestens eine Option auswählen!',

    // TODO

    On: 'Ein',
    Class: 'Klasse',
    Classes: 'Klassen',
    SOS: 'SOS',
    'Template is updated': 'Vorlage wird aktualisiert',
    'Options must differ ': 'Optionen müssen sich unterscheiden ',
    'Options must differ': 'Optionen müssen sich unterscheiden ',
    Open: 'Nicht-anonyme',
    'Click to get back to all Tasks': 'Klicken Sie, um zu allen Aufgaben zurückzukehren',
    'Choose the answer': 'Wählen Sie die Antwort',
    'Not selected': 'Nicht ausgewählt',
    Reset: 'Zurücksetzen',
    'What are 3 things that are a bit challenging at the moment?': 'What are 3 things that are a bit challenging at the moment?',
    'What’s just one thing you will do differently tomorrow?': 'What’s just one thing you will do differently tomorrow?',
    'all students': 'all students',
    'Can`t create student without create class': 'Can`t create student without create class',
    Analytics: 'Analysen',
    'Full Desktop version': 'Full Desktop version',
    'Full Mobile version': 'Full Mobile version',
    Frequency: 'Häufigkeit',
    'Download students credentials': 'Schüler:innen Anmeldedaten herunterladen',
    studentsCredentialsNotAvailable: 'Die Anmeldedaten der Schüler:innen sind noch nicht verfügbar. Bitte wende dich an den Support.',

    'Monitor student unease with this pre-set Sample Group': 'Monitor student unease with this pre-set Sample Group',
    Never: 'Nie',
    Sometimes: 'Manchmal',
    Often: 'Oft',
    Always: 'Immer',
    "If you don't agree to Terms and Conditions you are not going to be allowed to use the app!": 'Bitte Datenschutzbestimmungen zustimmen',
    Continue: 'Weiter',
    'Take action': 'Jetzt handeln',
    'Take Action': 'Jetzt handeln',
    'Anonymous user': 'Anonymer Benutzer',
    Accept: 'Akzeptieren',
    'Review content': 'Inhalt überprüfen',
    Decline: 'Ablehnen',
    'Content has been approved': 'Der Inhalt wurde genehmigt',
    'Content has been declined': 'Inhalt wurde abgelehnt',
    "You don't have any content to review": 'Sie haben keine Inhalte zum Überprüfen',
    "You don't have any upcoming content": 'Sie haben keine anstehenden Inhalte',

    'Search for students': 'Schüler:in suchen',
    Feeling: 'Gefühl',
    'Last online': 'Zuletzt online',
    'No data found': 'Keine Daten gefunden',
    'This element will be updated once enough app-activity has been recorded': 'Dieses Element wird aktualisiert, sobald genügend App-Aktivitäten aufgezeichnet wurden.',
    'Monitor Wellbeing': 'Wellbeing Beobachten',
    'What u wish to do?': 'Was möchtest du tun?',
    'Open Chat': 'Chat öffnen',
    'Assign Action': 'Aufgabe zuweisen',
    'Manage Student': 'Schüler:in verwalten',
    'Comfortable emotions since school year start': 'Angenehme Gefühle seit Beginn des Schuljahres',
    'Multiple Uncomfortable Emotions': 'Mehrere Unangenehme Emotionen',
    'Student checking vs class average': 'Schüler:in Check-Ins vs Klassendurchschnitt',
    'Class Average': 'Klassen​durchschnitt',
    ClassAverage: 'Klassen durchschnitt',
    'Same as class average': 'Gleich wie Klassendurchschnitt',
    'Less than class average': 'Weniger als Klassendurchschnitt',
    'More than class average': 'Mehr als Klassendurchschnitt',
    'Student activities vs class average': 'Schüler:in Aktivitäten vs Klassendurchschnitt',
    Completion: 'Aufgaben erledigt',
    'Class average': 'Klassen​durchschnitt',
    'completed activities': 'Aufgaben erledigt',
    Comparison: 'Vergleich',
    'Emotions logged': 'Emotionen eingetragen',
    'Class Average of Comfortable Emotions': 'Klassendurchschnitt Angenehmer Emotionen:',
    'Details on emotions': 'Details zu Emotionen',
    'Reasons for Emotions': 'Gründe für Emotionen',
    'Show More Reasons': 'Mehr Gründe Anzeigen',
    'Show Less Reasons': 'Weniger Gründe Anzeigen',
    Alerts: 'Warnungen',
    'Assigned Actions': 'Zugewiesene Aufgaben',
    'Assigned by': 'Zugewiesen von',
    Message: 'Nachricht',
    'Show More': 'Mehr anzeigen',
    'Show Less': 'Weniger anzeigen',
    'Participation in Activities': 'Teilnahme an Aktivitäten',
    "Check out John's responses to app activities": 'Sieh dir {{name}}s Antworten auf App-Aktivitäten an.',
    'Activities John has participated in': 'Aktivitäten an denen {{name}} teilgenommen hat',
    'Check-ins': 'Check-ins',
    'Average number of emotions submitted by student on daily basis': 'Durchschnittliche Anzahl von Emotionen, die von Schülern täglich eingereicht werden',
    'Number of emotion submitted on each day': 'Anzahl der an jedem Tag eingereichten Emotionen',

    'Search for activities': 'Aktivitäten suchen',
    'Average participation rate': 'Durchschnittliche Teilnahme',
    'Check activity responses here': 'Antworten zu Aktivitäten hier ansehen:',
    Remind: 'Erinnern',
    Details: 'Details',
    'View Less': 'Weniger sehen',
    'View All': 'Alle anzeigen',
    'Student check-ins overview': 'Schüler:in Check-Ins im Überblick',
    'Comfortable emotions': 'Angenehme Emotionen',
    'Uncomfortable emotions': 'Unangenehme Emotionen',
    'Not assigned': 'Nicht zugewiesen',
    'Assigned to me': 'Mir zugewiesen',
    'Assigned to others': 'Anderen zugewiesen',
    Completed: 'Erledigt',
    'took an action': 'hat eine Handlung durchgeführt',
    assigned: 'beauftragte',
    'with the following message': 'mit der folgenden Nachricht:',
    'Emotional Trends': 'Trend der Emotionen',
    'Time frame': 'Zeitraum',
    'Export PDF': 'PDF exportieren',

    StudentWellbeingThisYear: 'Schüler:in Wellbeing in diesem Schuljahr',
    TotalEmotions: 'Gesamtzahl eingetragener Emotionen',
    'Student Wellbeing Comparison': 'Schüler:in Wellbeing im Vergleich',

    comparison_to_average_year: 'Vergleich zum Jahrgangsdurchschnitt',
    comparison_to_average_class: 'Vergleich zum Klassendurchschnitt',
    wellbeing_above_average_year: '{{name}} ist {{percentage}}% über dem Jahrgangsdurchschnitt für Wellbeing - tolle Arbeit!',
    wellbeing_above_average_class: '{{name}} ist {{percentage}}% über dem Klassendurchschnitt für Wellbeing- tolle Arbeit!',
    wellbeing_bellow_average_year: '{{name}} ist {{percentage}}% unter dem Jahrgangsdurchschnitt für Wellbeing.',
    wellbeing_bellow_average_class: '{{name}} ist {{percentage}}% unter dem Klassendurchschnitt für Wellbeing.',

    wellbeing_equal_average_year: '{{name}} hat denselben Wohlbefindensprozentsatz wie der Jahresdurchschnitt, gut gemacht!',
    wellbeing_equal_average_class: '{{name}} hat denselben Wohlbefindensprozentsatz wie der Klassendurchschnitt, gut gemacht!',

    highestComfortableLabelMonth: 'Der Monat {{date}} hatte das höchste Niveau an angenehmen Emotionen.',
    highestComfortableLabelWeek: 'Die Woche von {{date}} hatte das höchste Niveau an angenehmen Emotionen.',
    highestComfortableLabelDay: '{{date}} hatte das höchste Niveau an angenehmen Emotionen.',

    highestUncomfortableLabelMonth: 'Der Monat {{date}} hatte das höchste Niveau an unangenehmen Emotionen.',
    highestUncomfortableLabelWeek: 'Die Woche von {{date}} hatte das höchste Niveau an unangenehmen Emotionen.',
    highestUncomfortableLabelDay: '{{date}} hatte das höchste Niveau an unangenehmen Emotionen.',

    'Emotional Wellbeing Factors': 'Faktoren für Emotionales Wellbeing',
    Assigned: 'Zugewiesen',
    Completed: 'Erledigt',

    'Show less': 'Weniger anzeigen',
    'Show more': 'Mehr anzeigen',
    Complete: 'Abgeschlossen',
    Status: 'Status',
    'This content is anonymous, so you won’t be able to see any responses': 'Dieser Inhalt ist anonym, daher kannst du keine Antworten sehen.',
    'View less': 'Weniger anzeigen',
    'View all': 'Alles anzeigen',
    Reminded: 'Erinnert',
    'Show less reasons': 'Weniger Gründe anzeigen',
    'Show more reasons': 'Mehr Gründe anzeigen',

    'Same number of check-ins this selected period compared to previous.': 'Gleiche Anzahl von Check-ins in diesem ausgewählten Zeitraum im Vergleich zum vorherigen.',
    'More check-ins this selected period compared to previous.': 'mehr Check-ins in diesem ausgewählten Zeitraum im Vergleich zum vorherigen.',
    'Fewer check-ins this selected period compared to previous.': 'weniger Check-ins in diesem ausgewählten Zeitraum im Vergleich zum vorherigen.',
    'Same number of comfortable emotions this selected period compared to previous':
        'Gleiche Anzahl von angenehmen Emotionen in diesem ausgewählten Zeitraum im Vergleich zum vorherigen.',
    'More comfortable emotions this selected period compared to previous': 'mehr angenehme Emotionen in diesem ausgewählten Zeitraum im Vergleich zum vorherigen.',
    'Fewer comfortable emotions this selected period compared to previous.': 'weniger angenehme Emotionen in diesem ausgewählten Zeitraum im Vergleich zum vorherigen.',

    'Search to see student analytics': 'Suche, um die Analysen eines Schülers zu sehen',
    'Use this search to find a student for deeper and advanced analytics': 'Verwenden Sie diese Suche, um einen Schüler für tiefere und fortgeschrittene Analysen zu finden',
    'This section displays the most common reasons behind the comfortable and uncomfortable emotions submitted by the student during the selected period':
        'Dieser Abschnitt zeigt die häufigsten Gründe hinter den angenehmen und unangenehmen Emotionen, die der Schüler im ausgewählten Zeitraum eingereicht hat',
    "This emotion shows student's last submitted mood check": 'Diese Emotion zeigt die zuletzt eingereichte Stimmungsüberprüfung des Schülers',
    Logged: 'Protokolliert',
    'This section displays alerts created for the student based on logged emotions or activities. You can view details, reasons, and the assigned status of each alert, and take or assign actions as needed.':
        'Dieser Abschnitt zeigt Warnungen, die für den Schüler basierend auf protokollierten Emotionen oder Aktivitäten erstellt wurden. Sie können Details, Gründe und den zugewiesenen Status jeder Warnung anzeigen und nach Bedarf Maßnahmen ergreifen oder zuweisen.',
    'This section displays all assigned actions based on the student’s activities. You can view the status of each assignment to see if any action has been taken.':
        'Dieser Abschnitt zeigt alle zugewiesenen Aktionen basierend auf den Aktivitäten des Schülers. Sie können den Status jeder Aufgabe anzeigen, um zu sehen, ob Maßnahmen ergriffen wurden.',
    'This section provides an overview of the student’s check-ins for the selected period. It shows the total number of check-ins, the percentage breakdown of comfortable and uncomfortable emotions, and highlights changes compared to the previous period.':
        'Dieser Abschnitt bietet einen Überblick über die Check-ins des Schülers für den ausgewählten Zeitraum. Es zeigt die Gesamtzahl der Check-ins, die prozentuale Aufteilung der angenehmen und unangenehmen Emotionen und hebt Veränderungen im Vergleich zum vorherigen Zeitraum hervor.',
    'This section shows trends in the student’s emotional check-ins over time. It highlights the percentage of comfortable and uncomfortable emotions, along with the time frame and number of check-ins. Key insights, such as the highest levels of comfortable and uncomfortable emotions, are displayed for better understanding.':
        'Dieser Abschnitt zeigt Trends in den emotionalen Check-ins des Schülers im Laufe der Zeit. Es hebt den Prozentsatz der angenehmen und unangenehmen Emotionen sowie den Zeitraum und die Anzahl der Check-ins hervor. Wichtige Erkenntnisse, wie die höchsten Werte angenehmer und unangenehmer Emotionen, werden zur besseren Verständlichkeit angezeigt.',
    'This section displays the activities created for the student during the selected period. You can remind the student to complete activities or view detailed information about each activity.':
        'Dieser Abschnitt zeigt die für den Schüler im ausgewählten Zeitraum erstellten Aktivitäten. Sie können den Schüler daran erinnern, Aktivitäten abzuschließen, oder detaillierte Informationen zu jeder Aktivität anzeigen.',
    'This section provides an overview of the student’s logged emotions for the current school year. It highlights the total number of emotions recorded, along with the breakdown of comfortable and uncomfortable emotions as percentages.':
        'Dieser Abschnitt bietet einen Überblick über die protokollierten Emotionen des Schülers für das aktuelle Schuljahr. Es hebt die Gesamtzahl der aufgezeichneten Emotionen sowie die Aufteilung der angenehmen und unangenehmen Emotionen in Prozent hervor.',
    'This section compares the student’s wellbeing data to the class and year averages for the selected period. It highlights differences in percentages, showing how the student’s performance aligns with or deviates from their peers':
        'Dieser Abschnitt vergleicht die Wohlfühldaten des Schülers mit den Klassen- und Jahresdurchschnittswerten für den ausgewählten Zeitraum. Es hebt prozentuale Unterschiede hervor und zeigt, wie die Leistung des Schülers mit der seiner Mitschüler übereinstimmt oder abweicht',
    'Occurs every Monday until 01/01/2025': 'Jeden {{day}}. bis {{date}}',

    //
    'Class wellbeing for this school year': 'Wellbeing der Klasse in diesem Schuljahr',
    'Class check-ins overview': 'Check-Ins der Klasse im Überblick ',
    'Class Wellbeing Comparison': 'Wellbeing der Klasse im Vergleich',
    'School average': 'Schuldurchschnitt',
    'Class Emotional Trends': 'Trends der Emotionen in der Klasse',
    'Year 3 average': 'Jahrgang {{yearName}} Durchschnitt',
    'Class Emotional Wellbeing Factors': 'Faktoren für Emotionales Wellbeing der Klasse',
    'John Doe has logged 3 uncomfortable emotions on': '{{first_name}} {{last_name}} hat {{number}} unangenehme Emotionen eingetragen am',
    'Class Engagement in Activities': 'Klassenteilnahme an Aktivitäten',
    'Average class participation rate': 'Durchschnittliche Klassenteilnahme',
    'Check class activity responses here': 'Antworten der Klasse zu Aktivitäten hier ansehen:',
    'Class participation': 'Klassenteilnahme',
    'Class Emotional Wellbeing by Student': 'Emotionales Wellbeing der Klasse pro Schüler:in',
    'See all students': 'Alle Schüler:innen anzeigen',

    'Search for student or class analytics': 'Suche nach Schüler:innen- oder Klassen-Analysen',
    'Search for classes': 'Suche nach Klassen',
    'Search for': 'Suche nach',
    Students: 'Schüler:innen',
    'Shows the total emotions logged by the class so far this year, with a simple breakdown into comfortable and uncomfortable emotions':
        'Zeigt alle eingetragenen Emotionen der Klasse in diesem Jahr, mit einer einfachen Übersicht über angenehme und unangenehme Emotionen.',
    'This section displays key factors impacting each student’s emotional wellbeing, with a breakdown of comfortable and uncomfortable emotions.':
        'Dieser Abschnitt zeigt die Hauptfaktoren, die das emotionale Wellbeing der Schüler:innen beeinflussen, mit einer Übersicht über angenehme und unangenehme Emotionen.',
    'Show less students': 'Weniger Schüler:innen anzeigen',
    Student: 'Schüler:in',
    'Shows the class’s emotional check-ins for the selected period, with a breakdown of comfortable and uncomfortable emotions.':
        'Zeigt die Emotionen-Check-Ins der Klasse für den ausgewählten Zeitraum mit einer Übersicht über angenehme und unangenehme Emotionen.',
    'Load More': 'Mehr laden',
    comparison_to_average_school: 'Vergleich zum Schuldurchschnitt',
    'This section shows alerts for students who have logged 3 consecutive uncomfortable emotions. You can use these alerts to monitor your students’ emotional wellbeing and take necessary actions.':
        'Dieser Abschnitt zeigt Warnhinweise für Schüler:innen, die drei aufeinanderfolgende unangenehme Emotionen eingetragen haben. Sie können diese Warnungen nutzen, um das emotionale Wellbeing Ihrer Schüler:innen zu beobachten und erforderliche Maßnahmen zu ergreifen.',
    'This section displays the average participation of the class in all activities over the selected period. Use this to monitor engagement and identify areas where students may need more support or encouragement':
        'Dieser Abschnitt zeigt die durchschnittliche Teilnahme der Klasse an allen Aktivitäten im ausgewählten Zeitraum. Nutzen Sie diese Informationen, um das Engagement zu beobachten und Bereiche zu identifizieren, in denen Schüler:innen möglicherweise mehr Unterstützung oder Motivation benötigen.',
    'This section displays the factors contributing to the class’s comfortable and uncomfortable emotions. View the breakdown of each emotion type, along with the most common contributing factors for the selected period.':
        'Dieser Abschnitt zeigt die Faktoren, die zu den angenehmen und unangenehmen Emotionen der Klasse beitragen. Sehen Sie die Übersicht der einzelnen Emotionstypen sowie die häufigsten Einflussfaktoren für den ausgewählten Zeitraum.',
    wellbeing_equal_average_school: '{{name}} hat den gleichen Wellbeing-Prozentsatz wie der Schuldurchschnitt',
    wellbeing_above_average_school: '{{name}} ist {{percentage}}% über dem Schuldurchschnitt für Wellbeing, tolle Arbeit!',
    wellbeing_bellow_average_school: '{{name}} ist {{percentage}}% unter dem Schuldurchschnitt für Wellbeing.',

    'Class analytics': 'Klassen-Analysen',
    'Student analytics': 'Schüler:innen-Analysen',
    'We found student(s)': 'Wir haben {{total}} Schüler:innen gefunden.',
    'We found class(es)': 'Wir haben {{total}} Klassen gefunden.',

    'Number of class engagements': 'Anzahl der Klassenbeteiligungen',
    'Average class participation rate': 'Durchschnittliche Beteiligung der Klasse',
    'Number of surveys': 'Anzahl der Umfragen',
    'Avg. participation rate': 'Durschnittliche Beteiligungsrate',
    'Number of polls': 'Anzahl der Abstimmungen',
    'Number of questions': 'Anzahl der Fragen',
    'Your class': 'Deine Klasse',
    'We found 5 result(s) based on your search': 'Wir haben {{total}} Ergebnis(se) gefunden, die Deiner Suche entsprechen.',
    'Classroom analytics': 'Klassenanalysen',
    Loading: 'Laden',
    'No data to show based on your search': 'Keine Daten, die auf Ihrer Suche basieren',

    'Skip guide': 'Skip guide',
    'Close guide': 'Close guide',
    'Next page': 'Next page',
    "Don't show again": "Don't show again",

    student_analytics_welcome: 'Willkommen auf der Schüler:innen-Analysen-Seite. Diese Tour führt Dich Schritt für Schritt durch diese neue Funktion.',
    student_analytics_student_info: 'In diesem Abschnitt siehst Du die wichtigsten Infos zu den Schüler:innen.',
    student_analytics_content: 'Hier kannst Du Einblicke in das Engagement und Wellbeing der Schüler:innen sehen.',
    student_analytics_personal_info: 'Hier werden die wichtigsten persönlichen Informationen der Schüler:innen angezeigt.',
    student_analytics_emotional_info: 'Hier siehst Du die Entwicklungen der Emotionen der Schüler:innen im letzten Jahr.',
    student_action_buttons: 'Mit diesen vier Buttons kannst Du weitere Schritte unternehmen, um die Schüler:innen zu unterstützen.',
    student_analytics_filter: 'Mit diesem Filter kannst Du einen bestimmten Zeitraum für die Analysen auswählen.',
    student_analytics_checkins: 'Dieser Abschnitt fasst die Emotionen Check-Ins der Schüler:innen zusammen und kategorisiert die Emotionen als angenehm oder unangenehm.',
    student_analytics_wellbeing_comparison: 'Hier kannst Du die Wellbeing-Trends der Schüler:innen mit ihrer Klasse oder ihrem Jahrgang vergleichen.',
    student_analytics_emotional_trends:
        'Diese Grafik zeigt die emotionalen Entwicklungen der Schüler:innen im Laufe der Zeit, basierend auf dem oben auf der Seite gewählten Zeitraum.',
    student_analytics_emotional_wellbeing_factors:
        'Dieser Abschnitt zeigt die Faktoren, die den emotionalen Zustand der Schüler:innen beeinflussen, aufgeteilt in zwei Bereiche. Klicke auf „Mehr Gründe anzeigen“, um alle gemeldeten angenehmen und unangenehmen Emotionen zu sehen.',
    student_analytics_alerts: 'Benachrichtigungen erscheinen hier, wenn Schüler:innen unangenehme Emotionen melden. Klicke auf den Button rechts für mehr Details.',
    student_analytics_alerts_single_item:
        'Jede Warnung enthält die Emotion, die dahinterliegenden Faktoren und das Datum der Meldung. Nutze die Buttons unten, um Maßnahmen zu ergreifen oder Unterstützung zuzuweisen.',
    student_analytics_assigned_actions:
        'Dieser Abschnitt zeigt alle zugewiesenen Maßnahmen für die Schüler:innen, einschließlich des Status, wer sie zugewiesen hat, an wen sie zugewiesen wurden, das Datum und alle zugehörigen Nachrichtea',
    student_analytics_participation: 'Dieser Abschnitt zeigt alle Aktivitäten, an denen die Schüler:innen teilgenommen haben.',
    student_analytics_participation_actions: 'Wenn Du auf den Button „Details“ klickst, kannst Du die Schüler:innen an Aktivitäten erinnern oder Aktivitätsdetails anzeigen.',

    class_analytics_welcome: 'Willkommen auf der Klassen-Analysen-Seite. Diese Tour führt Dich durch jeden Abschnitt.',
    class_analytics_class_info: 'Dieser Abschnitt zeigt die wichtigsten Infos zur Klasse.',
    class_analytics_content: 'Hier erhältst Du einen Überblick über die Analysen und Erkenntnisse zur Klasse.',
    class_analytics_info: 'Die Klasseninformationen werden hier angezeigt.',
    class_analytics_emotional_info: 'Hier siehst Du die Trends der Emotionen der Klasse im letzten Jahr.',
    class_analytics_filter: 'Mit diesem Filter kannst Du einen bestimmten Zeitraum für die Analysen auswählen.',
    class_analytics_checkins: 'Dieser Abschnitt fasst die Emotionen Check-Ins der Klasse zusammen und kategorisiert die Emotionen als angenehm oder unangenehm.',
    class_analytics_wellbeing_comparison: 'Dieser Abschnitt vergleicht die Wellbeing-Trends der Klasse mit dem Jahrgangs- und Schuldurchschnitt.',
    class_analytics_emotional_trends: 'Diese Grafik zeigt die emotionalen Entwicklungen der Klasse im Laufe der Zeit, basierend auf dem oben auf der Seite gewählten Zeitraum.',
    class_analytics_emotional_wellbeing_factors:
        'Dieser Abschnitt zeigt die Faktoren, die den emotionalen Zustand der Klasse beeinflussen, aufgeteilt in zwei Bereiche. Klicke auf „Mehr Gründe anzeigen“, um alle gemeldeten angenehmen und unangenehmen Emotionen zu sehen.',
    class_emotional_wellbeing_by_student: 'Dieser Abschnitt zeigt die angenehmen und unangenehmen Emotionen jeder Schüler:in in der Klasse für den ausgewählten Zeitraum.',
    class_emotional_wellbeing_by_student_single: 'Klicke auf den Eintrag eines/r Schüler:in, um die gemeldeten Emotionen und Faktoren einzusehen',
    class_analytics_alerts: 'Benachrichtigungen erscheinen hier, wenn mehrere Schüler:innen unangenehme Emotionen melden. Klicke auf den Button rechts für mehr Details.',
    class_analytics_alerts_single_item:
        'Jede Warnung enthält die Emotion, die dahinterliegenden Faktoren und das Datum der Meldung. Nutze die Buttons unten, um Maßnahmen zu ergreifen oder Unterstützung zuzuweisen.',
    class_analytics_assigned_actions:
        'Dieser Abschnitt zeigt alle zugewiesenen Maßnahmen für die Schüler:innen in der Klasse, einschließlich des Status, wer sie zugewiesen hat, an wen sie zugewiesen wurden, das Datum und alle zugehörigen Nachrichten.',
    class_analytics_participation: 'Dieser Abschnitt zeigt alle Aktivitäten, an denen die Schüler:innen der Klasse teilgenommen haben.',
    class_analytics_participation_actions: 'Klicke auf diese Buttons, um Erinnerungen zu senden oder Aktivitätsdetails anzuzeigen.',

    //TutorialModal
    'Next Tutorial': 'Weiter',
    'Previous Tutorial': 'Zurück',
    'Exciting New Analytics': 'Upstrive’s Neue Analytik!',
    'New Student, Class and Grade Analytics': 'Neue Schüler:innen-, Klassen- und Jahres-Analytik',
    'Better insights for you and your school': 'Bessere Einblicke für Dich und Deine Schule.',
    'Now you can see how a student or class is doing compared to their own data, other classes, or the entire grade.':
        'Jetzt kannst Du sehen, wie es Schüler:innen oder Klassen geht, im Vergleich zu ihren eigenen Daten, anderen Klassen, oder dem gesamten Jahrgang.',
    'Student Wellbeing Details': 'Wellbeing im Detail',
    'Check-Ins Overview': 'Check-Ins im Überblick',
    'Less data, more information': 'Weniger Daten, mehr Information :)',
    'See at a glance how often the student has checked in and the emotions they’ve logged.':
        'Sieh auf einen Blick, wie oft und welche Emotionen die Schüler:innen im Check-In eingetragen haben.',
    'Compare Students to Class': 'Vergleich mit der Klasse',
    'Get Deeper Insights': 'Tiefere Einblicke Gewinnen',
    'Get everything you need to make informed decisions.': 'Alles, was Du brauchst, um informierte Entscheidungen zu treffen.',
    'Quickly see how a student’s wellbeing compares to their class or year group.':
        'Erhalte schnell einen Überblick, wie sich Schüler:innen im Bereich Wellbeing im Vergleich zur Klasse oder dem Jahrgang entwickeln.',
    'Valuable Information': 'Wertvolle Informationen',
    'Powerful Wellbeing Analytics': 'Starke Wellbeing Analytik',
    'Get everything you need to make more informed decisions.': 'Alles, was Du brauchst, um informierte Entscheidungen zu treffen.',
    'Dive deep into wellbeing data to spot trends and draw meaningful conclusions.':
        'Tauche tief in die Wellbeing-Daten ein, um Trends zu erkennen und wichtige Erkenntnisse zu gewinnen.',
    'Actionable Classroom Data': 'Umsetzbare Klassendaten',
    'Explore Trends Across Classes and Grades': 'Entdecke Trends in Klassen und Jahrgängen',
    'Gain valuable insights into how your class is doing.': 'Gewinne wertvolle Einblicke, wie es Deiner Klasse geht.',
    'Uncover key wellbeing trends across classes and year groups.': 'Erkenne wichtige Wellbeing-Trends über verschiedene Klassen und Jahrgänge hinweg.',
    'Classroom Engagement': 'Klassenzimmer-Teilnahme',
    'Track student engagement in Upstrive activities': 'Beobachte die Teilnahme an Upstrive-Aktivitäten',
    'How are they doing?': 'Wie geht es ihnen?',
    'Get the insights you need to understand student engagement in Upstrive activities.':
        'Erhalte die Einblicke, die Du brauchst, um das Engagement der Schüler:innen in Upstrive-Aktivitäten zu verstehen.',
    'Accessing Analytics': 'Analysen anzeigen',
    'Search Smarter': 'Schlauer Suchen',
    'Enter a student or class name to access the new Analytics. You can also view student-specific insights by clicking on a student in the Classroom section.':
        'Gib den Namen von Schüler:innen oder Klassen ein, um die neuen Analysen zu finden. Die Schüler:innen-Analysen findest Du auch in der Klassenzimmeransicht, wenn Du auf einen Schüler:in klickst.',
    //TutorialModal

    '2 years ago': 'Vor {{number}} {{period}}',
    '2 months ago': 'Vor {{number}} {{period}}',
    '2 days ago': 'Vor {{number}} {{period}}',
    'Year average': 'Jahrgangs-durchschnitt',
    "This data compares your class's wellbeing to the average wellbeing of the year group and the school overall":
        'Diese Daten vergleichen das Wellbeing Deiner Klasse zum durchschnittlichen Wellbeing im Jahrgang und in der Schule insgesamt.',
    "Here you'll see the class's emotional wellbeing over the selected period, showing the breakdown of comfortable and uncomfortable emotions":
        'Hier siehst Du das emotionale Wellbeing Deiner Klasse im ausgewählten Zeitraum, mit einem Überblick der angenehmen und unangenehmen Emotionen.',
    "Here you'll find actions that have been assigned to students, including their current status (Assigned or Completed). Track who assigned the action, when it was assigned, and any comments or updates related to the action.":
        'Hier findest du Aufgaben, die Lehrkräften zugewiesen wurden, einschließlich ihres aktuellen Status (Zugewiesen oder Erledigt). Verfolge, wer die Aufgabe zugewiesen hat, wann sie zugewiesen wurde und alle dazugehörigen Kommentare oder Updates.',
    'has logged multiple uncomfortable emotions': 'hat mehrere unangenehme Emotionen eingetragen',

    Jan: 'Jan.',
    Feb: 'Feb.',
    Mar: 'Mär.',
    Apr: 'Apr.',
    May: 'Mai.',
    Jun: 'Jun.',
    Jul: 'Jul.',
    Aug: 'Aug.',
    Sep: 'Sep.',
    Oct: 'Okt.',
    Nov: 'Nov.',
    Dec: 'Dez.',

    'Browse All Classes': 'Alle Klassen durchsuchen',
    'Class not selected': 'Klasse nicht ausgewählt',
    'Click to move all to top': 'Klare Antworten',
    'Click “proceed” to get back to the class screen': 'Klicken Sie auf "Weiter", um zum Klassenbildschirm zurückzukehren.',
    Confirm: 'Bestätigen',
    'Does this best describe how you’re feeling right now,': 'Beschreibt dies am besten, wie Sie sich im Moment fühlen,',
    'Emotion successfully selected': 'Emotion erfolgreich ausgewählt',
    'Emotions distribution': 'Verteilung der Emotionen',
    'Get Back': 'Zurück',
    'Get Deeper Insights': 'Hier kannst du Trends verfolgen',
    'It is needed to prevent students from entering teacher’s environment': 'Es wird benötigt, um zu verhindern, dass Schüler in den Bereich der Lehrer gelangen',
    'Main Dashboard': 'Haupt-Dashboard',
    'My Classes': 'Meine Klassen',
    'Open analytics': 'Analysen öffnen',
    Selected: 'Ausgewählt',
    Proceed: 'Weiter',
    Profile: 'Profil',
    'Repeat security key': 'Sicherheitsschlüssel wiederholen',
    'Repeat security key here': 'Wiederholen Sie hier den Sicherheitsschlüssel',
    'Search Class': 'Klasse suchen',
    "Secret keys don't match": 'Die Geheimschlüssel stimmen nicht überein...',
    'Setup your security key first': 'Richten Sie zuerst Ihren Sicherheitsschlüssel ein',
    'Stay up to date with student support': 'Bleiben Sie auf dem Laufenden mit der Schülerunterstützung',
    'Enter your security key to access settings': 'Um die Einstellungen zu betreten, geben Sie Ihren Sicherheitsschlüssel ein',
    'Enter your security key to reset your answers': 'So setzen Sie Antworten zurück Schreiben Sie Ihren Sicherheitsschlüssel',
    'Enter your security key to switch from the child view to the teacher view':
        'Gib deinen Sicherheitsschlüssel ein, um von der Kinderansicht zur Lehrer:innenansicht zu wechseln.',
    'User Management': 'Benutzerverwaltung',
    'Which image best describes how you’re feeling right now?': 'Welches Bild beschreibt am besten, wie Sie sich im Moment fühlen?',
    'Wrong secret key': 'Falscher geheimer Schlüssel',
    afraid: 'Ängstlich',
    'Security Key': 'Sicherheitsschlüssel',
    'Security key is needed to switch from child environment to teacher environment':
        'Der Sicherheitsschlüssel wird benötigt, um von der Kinderumgebung zur Lehrerumgebung zu wechseln',
    'Congrats!': 'Glückwunsch!',
    'Security key has been set': 'Der Sicherheitsschlüssel wurde festgelegt',
    Logout: 'Ausloggen',
    Settings: 'Einstellungen',
    'Change Avatars': 'Änderung der Avatare',
    'Go to Class Analytics': 'Zu Class Analytics gehen',
    'Browse emotion distribution': 'Emotionsverteilung durchsuchen',
    Dashboard: 'Überblick',
    Congratulations: 'Herzlichen Glückwunsch',
    'Everyone replied': 'Alle haben geantwortet',
    'No one replied yet': 'Es hat noch niemand geantwortet',
    'Open Student View': 'Kinderansicht öffnen',
    'Open Upstrive Education': 'Öffnen Sie Upstrive Education',
    'Open Upstrive Early': 'Öffnen Sie Upstrive Early',

    //alerts section
    'All alerts': 'Alle Warnungen',
    'Keyword alerts': 'Schlüsselwort-Warnungen',
    'Keyword Alert': 'Schlüsselwort-Warnung',
    'Help us improve': 'Hilf uns, besser zu werden',
    'How would you rate the accuracy of flagging this comment as a risk? From low (1) to high (5)':
        'Wie würdest du die Genauigkeit der Risikoeinstufung diese Kommentars bewerten? Von niedrig (1) bis hoch (5).',
    'Mark as false alert': 'Als Fehlwarnung markieren',
    'Thank you for helping us!': 'Danke für deine Hilfe!',
    'Your feedback helps us improve our system for detecting keywords!': 'Dein Feedback hilft uns, unser System zur Erkennung von Stichwörtern zu verbessern!',

    'AI-Powered Wellbeing Alerts – Important Notice': 'KI-Gestützte Risiko-Warnungen Wichtiger Hinweis',
    'Number of emotions to trigger an alert': 'Anzahl der Emotionen, um eine Warnung auszulösen',
    'Email notifications': 'Email-Mitteilungen',
    'Emotions to track': 'Emotions-Tracking',
    'Choose how many times a student must select an uncomfortable emotion before an alert is triggered, and select which emotions you want to track':
        'Wähle, wie oft ein:e Schüler:in eine unangenehme Emotion eintragen muss, bevor eine Benachrichtigung ausgelöst wird, und wähle aus, welche Gefühle du verfolgen möchtest.',
    'Here you can manage who will receive the email notifications for different types of alerts':
        'Hier kannst du verwalten, wer E-Mail-Benachrichtigungen für verschiedene Arten von Warnungen erhält.',
    'Here you can manage who will receive the in-app notifications for different types of alerts':
        'Hier kannst du verwalten, wer In-App-Mitteilungen für verschiedene Arten von Warnungen erhält.',
    'Here you can manage who will receive the push notifications for different types of alerts':
        'Hier kannst du verwalten, wer Push-Mitteilungen für verschiedene Arten von Warnungen erhält.',
    'In-App': 'In-App',
    'In-app notifications': 'In-App-Mitteilungen',
    'Keyword alerts receipient(s) email': 'Schlüsselwort-Warnungen Empfänger:innen (E-Mail)',
    'Keyword alerts receipient(s) notifications': 'Stichwort-Warnungen Empfänger (Mitteilung)',
    'No matching options': 'Keine passenden Optionen',
    'Custom email': 'Benutzerdefinierte E-Mail',
    Triggers: 'Auslöser',
    'Uncomfortable emotions receipient(s) email': 'E-Mail-Empfänger:innen für unangenehme Emotionen',
    'Uncomfortable emotions receipient(s) notifications': 'Benachrichtigungs-Empfänger:innen für unangenehme Emotionen',
    'Uncomfortable emotions triggers': 'Unangenehme Emotionen Auslöser',
    notificationSettings: 'Mitteilungs-Einstellungen',
    'Notifications settings': 'Mitteilungs-Einstellungen',
    push: 'Push',
    pushNotifications: 'Push-Mitteilungen',
    'included in their response': 'in ihrer Antwort enthalten',
    'If needed, you can flag this comment': 'Falls nötig, kannst du diesen Kommentar markieren',
    'Mark comment as risk': 'Kommentar als Risiko markieren',
    'See alert': 'Warnung anzeigen',
    'This comment has not been marked as a risk, you can change that by clicking the button':
        'Dieser Kommentar wurde nicht als Risiko markiert. Du kannst das ändern, indem du auf den Button klickst.',
    'This entry was flagged by AI for': 'Dieser Eintrag wurde von der KI wegen [{{category}}] markiert!',
    'Keyword settings': 'Stichwort-Optionen',
    violence: 'Gewalt',
    'self harm': 'Selbstverletzung',
    sexual: 'Sexuell',
    hate: 'Hass',
    harassment: 'Belästigung',
    'sexual/minors': 'Sexuell/Minderjährige',
    'self-harm/intent': 'Selbstverletzung/Absicht',
    "Don't show me this in the future": 'Zeig mir dies in Zukunft nicht mehr',
    'I Understand': 'Ich verstehe',
    'in a row': 'in Folge',
    'This entry was flagged by': 'Dieser Eintrag wurde markiert von {{name}}',
    Numbness: 'Taubheit',
    Worry: 'Besorgnis',
    Stress: 'Stress',
    Sadness: 'Traurigkeit',
    Anger: 'Wut',
    Lethargy: 'Trägheit',
    Grumpiness: 'Verärgerung',
    'Feeling emotionally disconnected or unable to process emotions':
        'Das Gefühl, von den eigenen Emotionen entfremdet zu sein oder Schwierigkeiten zu haben, diese zu verarbeiten.',
    'Feeling uneasy about something uncertain or future-related': 'Das Gefühl der Unruhe über etwas Ungewisses oder Zukünftiges.',
    'Feeling overwhelmed or pressured due to challenges, responsibilities, or expectations':
        'Das Gefühl, überfordert oder unter Druck gesetzt zu sein aufgrund von Herausforderungen, Verantwortlichkeiten oder Erwartungen.',
    'A deep feeling of unhappiness or disappointment': 'Ein tiefes Gefühl von Unglück oder Enttäuschung.',
    'A strong feeling of frustration or annoyance, often in response to something unfair or upsetting':
        'Ein starkes Gefühl von Frustration oder Ärger, oft als Reaktion auf Ungerechtigkeit oder etwas, das einen stört.',
    'Feeling tired, drained, sluggish, or low in energy': 'Ein Gefühl der Müdigkeit, Erschöpfung, Antriebslosigkeit oder Energiemangel.',
    'Feeling irritated or easily annoyed, sometimes without a clear reason': 'Ein Gefühl der Reizbarkeit oder leichten Irritation, manchmal ohne einen klaren Grund.',
    'Start Journalling!': 'Tagebuch starten!',

    //to be translated
    'Select who gets notified when a student selects uncomfortable emotions over multiple consecutive check-ins':
        'Wähle aus, wer benachrichtigt wird, wenn ein:e Schüler:in bei mehreren aufeinanderfolgenden Check-ins unangenehme Emotionen auswählt.',
    'Choose who should receive emails when a student uses flagged keywords in their check-in comments':
        'Wähle aus, wer E-Mails erhalten soll, wenn ein:e Schüler:in markierte Schlüsselwörter in seinen:ihren Check-in-Kommentaren verwendet.',
    'Manage who receives email notifications for different types of alerts triggered by student check-ins':
        'Verwalte, wer E-Mail-Benachrichtigungen für verschiedene Arten von Warnungen erhält, die durch Schüler:innen-Check-ins ausgelöst werden.',
    'Select who should receive push notifications for flagged keywords and for multiple consecutive uncomfortable emotions logged':
        'Wähle aus, wer Push-Benachrichtigungen erhalten soll, für markierte Schlüsselwörter und für mehrere aufeinanderfolgende unangenehme Emotionen.',
    'Select who should receive push notifications when a student’s check-in includes flagged keywords':
        'Wähle aus, wer Push-Benachrichtigungen erhalten soll, für markierte Schlüsselwörter und für mehrere aufeinanderfolgende unangenehme Emotionen.',
    'Select who should receive push notifications when students select uncomfortable emotions over multiple consecutive check-ins':
        'Wähle aus, wer Push-Benachrichtigungen erhalten soll, wenn Schüler:innen bei mehreren aufeinanderfolgenden Check-ins unangenehme Emotionen auswählen.',
    'Manage how many times uncomfortable emotions need to appear before triggering an alert, and choose which emotions to track':
        'Lege fest, wie oft unangenehme Emotionen auftreten sollen, bevor eine Benachrichtigung ausgelöst wird, und wähle aus, welche Emotionen verfolgt werden sollen.',
    'Select how many days in a row a student must log uncomfortable emotions before an alert is sent':
        'Wähle aus, wie viele Tage in Folge ein:e Schüler:in unangenehme Emotionen eintragen muss, bevor eine Benachrichtigung gesendet wird.',
    'Choose which specific uncomfortable emotions will be monitored for alerts': 'Wähle aus, welche unangenehmen Emotionen für Benachrichtigungen überwacht werden sollen',
    content: 'Inhalt',

    visitOurWebsiteForMoreDetails: 'Besuche unsere <white>Website</white> für mehr Details',

    'Alerts for selected student groups': 'Warnungen für ausgewählte Schüler:innengruppen',
    'All Activities': 'Alle Aktivitäten',
    'All classes': 'Alle Klassen',
    'By number of alerts': 'Nach Anzahl der Warnungen',
    'By number of assigned': 'Nach Anzahl von "Zugewiesen"',
    'By number of unassigned': 'Nach Anzahl von "Nicht zugewiesen"',
    'Check-ins overview for selected student groups': 'Übersicht der Check-ins für ausgewählte Schüler:innengruppen',
    Comfortable: 'Angenehm',
    'Counsellor analytics': 'Schulweite Analysen',
    'Counselor Emotional Wellbeing Factors': 'Faktoren für Emotionales Wellbeing der Schule',
    'Demo text': 'Demotext',
    'Emotional trends for selected student groups': 'Trends der Emotionen bei ausgewählten Schüler:innengruppen',
    'Engagement in activities for selected student groups': 'Teilnahme an Aktivitäten von ausgewählten Schüler:innengruppen',
    'Option 1': 'Option 1',
    'Option 2': 'Option 2',
    'School average - emotions logged': 'Schuldurchschnitt - {{number}} eingetragene Emotionen',
    'See Class Analytics': 'Klassenanalysen ansehen',
    'See all years': 'Alle Jahre anzeigen',
    'See analytics': 'Analysen ansehen',
    'See Analytics': 'Analysen ansehen',
    'Select all classes': 'Alle Klassen auswählen',
    'Show less Years': 'Weniger Jahre anzeigen',
    'Wellbeing comparison for selected student groups': 'Wellbeing-Vergleich für ausgewählte Schüler:innengruppen',
    'Year 1 average': 'Durchschnitt Jahr {{name}}',
    alerts: 'Warnungen',
    has: 'hat',
    unassigned: 'nicht zugewiesen',
    'See less years': 'Weniger Jahre anzeigen',
    'Whole school': 'Gesamte Schule',
    alert: 'Warnung',

    'Compare the wellbeing of different groups against the school average to spot trends and outliers.':
        'Vergleiche das Wellbeing verschiedener Gruppen mit dem Schuldurchschnitt, um Trends und Ausreißer zu erkennen.',
    Counsellor: 'Schule',
    'This data shows the ratio of logged emotions from the start of the school year until today':
        'Diese Daten zeigen das Verhältnis der eingetragenen Emotionen vom Beginn des Schuljahres bis heute.',
    'More comfortable emotions logged during this period compared to the previous one.': 'Mehr angenehme Emotionen eingetragen in diesem Zeitraum im Vergleich zum vorherigen.',
    'Overall balance of emotions logged since the start of the school year.': 'Gesamtübersicht der eingetragenen Emotionen seit Schuljahresbeginn.',
    'Same number of check-ins recorded during this period compared to the previous one': 'Gleiche Anzahl an Check-ins in diesem Zeitraum wie im vorherigen.',
    'Same number of comfortable emotions logged during this period compared to the previous one.': 'Gleiche Anzahl an angenehmen Emotionen in diesem Zeitraum wie im vorherigen.',
    'School-wide emotional breakdown based on number check-ins': 'Schulweite emotionale Auswertung basierend auf {{number}} Check-ins',
    'Search All Analytics': 'Alle Analysen durchsuchen',
    'See how feeling factors are influencing students’ emotions.': 'Sieh, wie Gefühlsfaktoren die Emotionen der Schüler:innen beeinflussen.',
    'Select which classes to include in the school-wide analytics view.': 'Wähle aus, welche Klassen in der schulweiten Analyseansicht enthalten sein sollen.',
    'Track how selected groups are engaging with activities, programs, and content.':
        'Verfolge, wie die ausgewählten Gruppen sich mit Aktivitäten, Programmen und Inhalten beschäftigen.',
    'Use this search to explore student, class, or counsellor analytics and access deeper insights.':
        'Nutze diese Suche, um Schüler:innen-, Klassen- oder schulweite Analysen zu erkunden und tiefere Einblicke zu erhalten.',
    'View all keyword and emotion alerts for selected year groups.': 'Alle Schlüsselwort- und Emotionswarnungen für ausgewählte Jahrgänge anzeigen.',
    'View check-in and emotion trends over time to spot changes in student engagement':
        'Check-in- und Emotionstrends im Laufe der Zeit ansehen, um Veränderungen im Engagement der Schüler:innen zu erkennen.',
    'View trends in comfortable and uncomfortable emotions to spot key patterns and peaks.':
        'Trends in angenehmen und unangenehmen Emotionen ansehen, um wichtige Muster und Höhepunkte zu erkennen.',
    'fewer check-ins recorded during this period compared to the previous one': 'weniger Check-ins in diesem Zeitraum im Vergleich zum vorherigen',
    'fewer comfortable emotions logged during this period compared to the previous one.': 'weniger angenehme Emotionen eingetragen in diesem Zeitraum im Vergleich zum vorherigen.',
    'more check-ins recorded during this period compared to the previous one': 'mehr Check-ins in diesem Zeitraum im Vergleich zum vorherigen',
    'Last email with password was sent': 'Letzte E-Mail mit Passwort gesendet',

    //translations for the german language
    'Nothing in Chat yet — new messages will appear here': 'Hier gibt es noch keine Nachrichten – neue Nachrichten erscheinen hier.',
    "I think I'm feeling this way because": 'Ich glaube, ich fühle mich so, weil',
    'No responses yet — check back soon!': 'Noch keine Antworten – schau bald wieder vorbei!',
    'Program successfully shared': 'Programm erfolgreich geteilt',

    //Upload engine words
    'Upload Type': 'Upload-Typ',

    '6 check-ins per student': '6 Check-ins pro Schüler:in',
    'All schools': 'Alle Schulen',
    'Number of check-ins on weekly basis in selected timeframe': 'Anzahl der Check-ins auf wöchentlicher Basis im ausgewählten Zeitraum',
    'Number of students': 'Anzahl der Schüler:innen',
    Organization: 'Organisation',
    'Organization analytics': 'Organisationsanalysen',
    'Organization average': 'Organisation Durchschnitt',
    'Organization average number': 'Organisation Durchschnittszahl',
    'See all organizations': 'Alle Organisationen anzeigen',
    'See less organizations': 'Weniger Organisationen anzeigen',
    'Select all schools': 'Alle Schulen auswählen',
    'Select which schools to include in the organization-wide analytics view.': 'Wähle aus, welche Schulen in der organisationsweiten Analyseansicht enthalten sein sollen.',
    'Student Check-In Activity': 'Student Check-In-Aktivität',
    'The average number of check-ins per student for the selected timeframe on weekly basis.':
        'Die durchschnittliche Anzahl der Check-ins pro Schüler:in für den ausgewählten Zeitraum auf wöchentlicher Basis.',
    'Year {{year}} average': 'Jahresdurchschnitt {{year}}',
    school_average: 'Schuldurchschnitt',
    backToForgotPassword: 'Zurück zu Passwort vergessen',
    backToLogin: 'Zurück zu Login',
    'Run journal': 'Tagebuch starten',
    //more words
    'Preparing your data': 'Preparing your data',
    'Number of responses per day': 'Number of responses per day',
    'Number of responses': 'Number of responses',
    'Actions taken': 'Actions taken',
    "Teachers' actions": "Teachers' actions",
    'Times logged': 'Times logged',
    '% of students': '% of students',
    Active: 'Active',
    'Add New Users': 'Add New Users',
    'Use this option to add students or staff during the school year while keeping everything else the same.':
        'Use this option to add students or staff during the school year while keeping everything else the same.',
    'Add-Only Requirements': 'Add-Only Requirements',
    Added: 'Added',
    'Adding New Users...': 'Adding New Users...',
    'Adding students during the year': 'Adding students during the year',
    'Adds only new users from your file': 'Adds only new users from your file',
    Admin: 'Admin',
    'Admin Created': 'Admin Created',
    'All critical issues have been resolved. Your data is ready to be submitted.': 'All critical issues have been resolved. Your data is ready to be submitted.',
    'All students treated as secondary (no early access column found)': 'All students treated as secondary (no early access column found)',
    'All users': 'All users',
    'Analyzing Excel data and preparing for import...': 'Analyzing Excel data and preparing for import...',
    'Animals Assigned': 'Animals Assigned',
    'Authority Issues': 'Authority Issues',
    'Authority Types': 'Authority Types',
    'Authority value does not match expected patterns (can be marked as teachers)': 'Authority value does not match expected patterns (can be marked as teachers)',
    'Authority/Role (required)': 'Authority/Role (required)',
    'Back to Settings': 'Back to Settings',
    'Back to Upload': 'Back to Upload',
    'Back to Upload Type': 'Back to Upload Type',
    'Basic Information': 'Basic Information',
    'Browse Files': 'Browse Files',
    'Choose Add New Users when': 'Choose Add New Users when',
    'Choose Whole School Update when': 'Choose Whole School Update when',
    'Choose Your Upload Method': 'Choose Your Upload Method',
    'Class Assignment': 'Class Assignment',
    'Class Assignment (required)': 'Class Assignment (required)',
    'Class Changes': 'Class Changes',
    'Classes to be Removed': 'Classes to be Removed',
    'Gives you a clean slate for the year ahead': 'Gives you a clean slate for the year ahead',
    'Clear existing data before importing (required for whole school update)': 'Clear existing data before importing (required for whole school update)',
    'Click to select': 'Click to select',
    'Click to send an email with your current upload details': 'Click to send an email with your current upload details',
    'Configure Import Settings': 'Configure Import Settings',
    'Continue to File Upload': 'Continue to File Upload',
    'Continue to Preview': 'Continue to Preview',
    'Continue to Settings': 'Continue to Settings',
    Created: 'Created',
    'Created At': 'Created At',
    'Creates classes if needed': 'Creates classes if needed',
    'Data Issues': 'Data Issues',
    'Data Issues Must Be Resolved': 'Data Issues Must Be Resolved',
    'Data Ready for Import': 'Data Ready for Import',
    'Data Replacement': 'Data Replacement',
    'Data preview': 'Data preview',
    'Department (optional)': 'Department (optional)',
    'Disables absent users': 'Disables absent users',
    'Download Template': 'Download Template',
    'Download the Excel template to get started with the correct format': 'Download the Excel template to get started with the correct format',
    'Drag and drop your Excel file': 'Drag and drop your Excel file',
    'Drop your file here': 'Drop your file here',
    'Duplicate Email Addresses': 'Duplicate Email Addresses',
    'Duplicate Emails': 'Duplicate Emails',
    'Duplicate IDs': 'Duplicate IDs',
    'Duplicate Student IDs': 'Duplicate Student IDs',
    Email: 'Email',
    'Email (required for secondary)': 'Email (required for secondary)',
    'Email (required)': 'Email (required)',
    'Email Address': 'Email Address',
    'Email will be sent on': 'Email will be sent on',
    'Enter a descriptive label for this email': 'Enter a descriptive label for this email',
    Error: 'Error',
    Errors: 'Errors',
    'Excel 2007+ (.xlsx)': 'Excel 2007+ (.xlsx)',
    'Excel 97-2003 (.xls)': 'Excel 97-2003 (.xls)',
    'Excel File Requirements': 'Excel File Requirements',
    'Existing users not in Excel will be disabled and old classes will be removed.': 'Existing users not in Excel will be disabled and old classes will be removed.',
    'File Information': 'File Information',
    'File Name': 'File Name',
    'File Requirements': 'File Requirements',
    'File Size': 'File Size',
    'File Structure': 'File Structure',
    'File Uploaded Successfully!': 'File Uploaded Successfully!',
    'Fine-tune how your data will be imported based on your selected upload method': 'Fine-tune how your data will be imported based on your selected upload method',
    'Force users to change their password on first login for enhanced security': 'Force users to change their password on first login for enhanced security',
    'Full Access': 'Full Access',
    'Full Name': 'Full Name',
    'Full Name (required)': 'Full Name (required)',
    'Whole School Update': 'Whole School Update',
    'Full Update Requirements': 'Full Update Requirements',
    'Full access to all students and staff data': 'Full access to all students and staff data',
    'Gender (optional)': 'Gender (optional)',
    'HOY Created': 'HOY Created',
    'Having Issues? Contact Support': 'Having Issues? Contact Support',
    'Head of Key Stage': 'Head of Key Stage',
    ID: 'ID',
    'Identifying student and staff data sheets': 'Identifying student and staff data sheets',
    'Storing the Excel file, please wait...': 'Excel-Datei wird gespeichert, bitte warten...',
    'Excel File Not Stored': 'Excel-Datei nicht gespeichert',
    'Retry Upload': 'Upload wiederholen',
    'Could not store the Excel file. Please retry the upload before continuing.': 'Die Excel-Datei konnte nicht gespeichert werden. Bitte wiederhole den Upload, bevor du fortfährst.',
    'School Data Upload Not Available': 'Upload von Schuldaten nicht verfügbar',
    'Your school data is synchronised automatically through your MIS integration, so no Excel upload is needed.':
        'Die Daten deiner Schule werden automatisch über deine MIS-Integration synchronisiert, daher ist kein Excel-Upload nötig.',
    'Back to Management': 'Zurück zur Verwaltung',
    'Import Failed': 'Import Failed',
    'Import User Data': 'Import User Data',
    'Important: Data Replacement Warning': 'Important: Data Replacement Warning',
    'In Progress': 'In Progress',
    Info: 'Info',
    'Invalid Gender Data': 'Invalid Gender Data',
    Issue: 'Issue',
    Issues: 'Issues',
    'Keep existing data and only add new records (required for add-only mode)': 'Keep existing data and only add new records (required for add-only mode)',
    Label: 'Label',
    'List of all scheduled emails with their details': 'List of all scheduled emails with their details',
    'Manages Primary (Years 1-6 + Early Years) or Secondary (Years 7-13) sections': 'Manages Primary (Years 1-6 + Early Years) or Secondary (Years 7-13) sections',
    'Master List': 'Master List',
    'Master List Stats': 'Master List Stats',
    'Mid-Year Updates': 'Mid-Year Updates',
    'Missing Class': 'Missing Class',
    'Missing Class Assignment': 'Missing Class Assignment',
    'Missing Email Addresses': 'Missing Email Addresses',
    'Missing Emails': 'Missing Emails',
    'Missing Passwords': 'Missing Passwords',
    'Missing Passwords (Warning)': 'Missing Passwords (Warning)',
    'Missing Student IDs': 'Missing Student IDs',
    'Missing Student Names': 'Missing Student Names',
    'Must include headers': 'Must include headers',
    Name: 'Name',
    'Need Help? Contact Support': 'Need Help? Contact Support',
    'New Classes': 'New Classes',
    'New Classes to be Added': 'New Classes to be Added',
    'New School Year Setup': 'New School Year Setup',
    'New Staff': 'New Staff',
    'New Staff to be Added': 'New Staff to be Added',
    'New users only': 'New users only',
    'No Class Assigned': 'No Class Assigned',
    'No Previous Uploads': 'No Previous Uploads',
    'No password column found. All students will receive system-generated passwords.': 'No password column found. All students will receive system-generated passwords.',
    'No password columns detected in uploaded data. Secure passwords will be auto-generated.':
        'No password columns detected in uploaded data. Secure passwords will be auto-generated.',
    'No previous uploads found': 'No previous uploads found',
    'No scheduled emails found': 'No scheduled emails found',
    'No students in this category': 'No students in this category',
    'No upload history found': 'No upload history found',
    'Not required': 'Not required',
    'Not set': 'Not set',
    Note: 'Note',
    'Number of critical issues': 'Number of critical issues',
    'Number of warnings': 'Number of warnings',
    'Only new users will be added. Existing users and classes remain unchanged.': 'Only new users will be added. Existing users and classes remain unchanged.',
    'Optional, but use standard values when provided': 'Optional, but use standard values when provided',
    Password: 'Password',
    'Password (optional)': 'Password (optional)',
    'Password Reset': 'Password Reset',
    'Password column detected but not enabled in settings': 'Password column detected but not enabled in settings',
    'Password columns detected': 'Password columns detected',
    'Passwords from Excel sheet will be used for staff accounts': 'Passwords from Excel sheet will be used for staff accounts',
    'Passwords will be saved securely and can be accessed by administrators when needed': 'Passwords will be saved securely and can be accessed by administrators when needed',
    Pending: 'Pending',
    'Please review and fix the issues in the detailed tabs below before submitting your data.':
        'Please review and fix the issues in the detailed tabs below before submitting your data.',
    Populated: 'Populated',
    'Preparing data for import configuration': 'Preparing data for import configuration',
    'Keeps existing accounts unchanged': 'Keeps existing accounts unchanged',
    Preview: 'Preview',
    'Preview & Submit': 'Preview & Submit',
    'Previous Uploads': 'Previous Uploads',
    'Primary Processed': 'Primary Processed',
    'Primary Students': 'Primärschüler:innen',
    'Primary students: Not required': 'Primary students: Not required',
    'Primary students: Optional': 'Primary students: Optional',
    Processed: 'Processed',
    Processing: 'Processing',
    'Processing Results': 'Processing Results',
    'Processing Your File': 'Processing Your File',
    'Processing progress': 'Processing progress',
    Progress: 'Progress',
    'Quick Decision Guide': 'Quick Decision Guide',
    'Reading and parsing your Excel file structure': 'Reading and parsing your Excel file structure',
    Ready: 'Ready',
    'Ready to process': 'Ready to process',
    'Recommended for new school year': 'Recommended for new school year',
    'Recommended for new users and security compliance': 'Recommended for new users and security compliance',
    'Release to upload': 'Release to upload',
    'Remove File': 'Remove File',
    'Removed Classes': 'Removed Classes',
    'Renamed Classes': 'Umbenannte Klassen',
    'Existing classes to be renamed': 'Bestehende Klassen, die umbenannt werden',
    'Existing Name': 'Bisheriger Name',
    'New Name': 'Neuer Name',
    'Removed Staff': 'Removed Staff',
    'Removes unused classes': 'Removes unused classes',
    'Use this option when starting a new school year or setting up your school on Upstrive for the first time.':
        'Use this option when starting a new school year or setting up your school on Upstrive for the first time.',
    'Replaces all student & staff data with your new file': 'Replaces all student & staff data with your new file',
    Required: 'Required',
    'Required for all students': 'Required for all students',
    'Required for all students (treated as secondary)': 'Required for all students (treated as secondary)',
    Retry: 'Retry',
    'Review and Submit Your Data': 'Review and Submit Your Data',
    'Review the processed data before submitting to ensure everything looks correct': 'Review the processed data before submitting to ensure everything looks correct',
    'Safe Addition Mode': 'Safe Addition Mode',
    'Recommended for mid-year updates': 'Recommended for mid-year updates',
    'Safe to use anytime during the year': 'Safe to use anytime during the year',
    'Save Passwords to Master list': 'Save Passwords to Master list',
    Schedule: 'Schedule',
    'Schedule Email': 'Schedule Email',
    'Schedule New Email': 'Schedule New Email',
    'Schedule email for new users': 'Schedule email for new users',
    'Scheduled Emails': 'Scheduled Emails',
    'Scheduled Emails for this Upload': 'Scheduled Emails for this Upload',
    'Scheduled for': 'Scheduled for',
    'School Data Upload': 'School Data Upload',
    Secondary: 'Secondary',
    'Secondary Processed': 'Secondary Processed',
    'Secondary Students': 'Secondary Students',
    'Secondary students': 'Secondary students',
    'Secondary students without email': 'Secondary students without email',
    'Secondary students: Required and must be unique': 'Secondary students: Required and must be unique',
    Select: 'Select',
    'Select an Excel file containing user information for bulk import': 'Select an Excel file containing user information for bulk import',
    'Select an upload method to continue': 'Select an upload method to continue',
    'Decide if you want a full reset for a new school year, or just add new users during the year.':
        'Decide if you want a full reset for a new school year, or just add new users during the year.',
    'Selected Method': 'Selected Method',
    'Selected Upload': 'Selected Upload',
    Selection: 'Selection',
    'Separate sheets for students/staff': 'Separate sheets for students/staff',
    Staff: 'Staff',
    'Staff Changes': 'Staff Changes',
    'Staff Data': 'Staff Data',
    'Staff ID (required)': 'Staff ID (required)',
    'Staff to be Removed': 'Staff to be Removed',
    'Starting a new academic year': 'Starting a new academic year',
    'Store passwords from Excel file in a secure master list for administrative purposes': 'Store passwords from Excel file in a secure master list for administrative purposes',
    'Student Data': 'Student Data',
    'Student Data Requirements': 'Student Data Requirements',
    'Student ID': 'Student ID',
    'Student ID (required)': 'Student ID (required)',
    'Student Type': 'Student Type',
    Summary: 'Summary',
    'Supported Formats': 'Supported Formats',
    'System-generated': 'System-generated',
    'System-generated for all students': 'System-generated for all students',
    'Target group': 'Target group',
    Teacher: 'Teacher',
    Teachers: 'Teachers',
    'Teachers Assigned': 'Teachers Assigned',
    'Teachers without specific class assignments (can be manually set)': 'Teachers without specific class assignments (can be manually set)',
    'The following errors were found': 'The following errors were found',
    'The following warnings were found': 'The following warnings were found',
    'This tool helps you to schedule emails for users based on their timezone': 'This tool helps you to schedule emails for users based on their timezone',
    'This will permanently remove users and classes not in your Excel file': 'This will permanently remove users and classes not in your Excel file',
    'Total Staff': 'Total Staff',
    'Total Students': 'Total Students',
    Type: 'Type',
    'Total Classes': 'Total Classes',
    'Unknown Format': 'Unknown Format',
    'Update School Data': 'Update School Data',
    Updated: 'Updated',
    'Updated At': 'Updated At',
    'Updating School Data...': 'Updating School Data...',
    Upload: 'Upload',
    'Upload Successful!': 'Upload Successful!',
    'Upload Details': 'Upload Details',
    'Upload File': 'Upload File',
    'Upload Method': 'Upload Method',
    'Upload Another': 'Upload Another',
    'Use Excel Passwords': 'Use Excel Passwords',
    'Use password values from the Excel file if available, otherwise generate secure passwords':
        'Use password values from the Excel file if available, otherwise generate secure passwords',
    'Used from Excel when available': 'Used from Excel when available',
    'Used from Excel when available for all students': 'Used from Excel when available for all students',
    'User Type': 'User Type',
    'Valid Entries': 'Valid Entries',
    'Valid Student Records': 'Valid Student Records',
    'Validating data format and required fields': 'Validating data format and required fields',
    'View All Scheduled': 'View All Scheduled',
    Warning: 'Warning',
    Warnings: 'Warnings',
    'Will be auto-generated': 'Will be auto-generated',
    'Write your personal notes here (only you can see this)': 'Write your personal notes here (only you can see this)',
    'You have complete, current data': 'You have complete, current data',
    'You want to keep existing accounts': 'You want to keep existing accounts',
    'You want to remove inactive accounts': 'You want to remove inactive accounts',
    'Your Excel file has been processed and is ready for import': 'Your Excel file has been processed and is ready for import',
    'Your Excel file should contain ALL current students and staff. Missing users will be disabled.':
        'Your Excel file should contain ALL current students and staff. Missing users will be disabled.',
    'Your Excel file should only contain NEW students and staff to be added to the system.':
        'Your Excel file should only contain NEW students and staff to be added to the system.',
    'Your file only has new users': 'Your file only has new users',
    across1YearGroup: 'across1YearGroup',
    across5YearGroups: 'across5YearGroups',
    actions: 'actions',
    added: 'added',
    admin: 'admin',
    authority: 'authority',
    dataIssue: 'dataIssue',
    duplicateRecord: 'duplicateRecord',
    duplicateWithRecord: 'duplicateWithRecord',
    fullAccess: 'fullAccess',
    headOfKeyStage: 'headOfKeyStage',
    id: 'id',
    invalidGender: 'invalidGender',
    issue: 'issue',
    keyStage: 'keyStage',
    markAllAsTeachers: 'markAllAsTeachers',
    markAsTeacher: 'markAsTeacher',
    markAsTeachers: 'markAsTeachers',
    markUnknownFormatAsTeachers: 'markUnknownFormatAsTeachers',
    missingClass: 'missingClass',
    missingEmailSecondary: 'missingEmailSecondary',
    missingId: 'missingId',
    missingNameData: 'missingNameData',
    missingPasswordSecondary: 'missingPasswordSecondary',
    missingPasswords: 'missingPasswords',
    noClassAssigned: 'noClassAssigned',
    noClassAssignedAuthority: 'noClassAssignedAuthority',
    noScopeDefined: 'noScopeDefined',
    none: 'none',
    notSet: 'notSet',
    ofStaff: 'ofStaff',
    'or click the button below to browse your files': 'or click the button below to browse your files',
    records: 'records',
    scope: 'scope',
    scopeField: 'scopeField',
    unknown: 'unknown',
    unknownFormat: 'unknownFormat',
    updated: 'updated',

    //more words
    'Describe how you will respond': 'Beschreibe, wie du reagieren wirst',
    'Assign to': 'Zuweisen an',

    Actions: 'Aktionen',
    'Additional Options': 'Zusätzliche Optionen',
    All: 'Alle',
    'Are you sure you want to delete this scheduled email?': 'Sind Sie sicher, dass Sie diese geplante E-Mail löschen möchten?',
    'Delete scheduled email': 'Geplante E-Mail löschen',
    'Disable password prompt': 'Passwortaufforderung deaktivieren',
    'Turn off new password prompt at login': 'Aufforderung zur Eingabe eines neuen Passworts beim Login deaktivieren',
    'Email scheduled successfully': 'E-Mail erfolgreich geplant',
    'Email will be sent on': 'E-Mail wird gesendet am',
    'Error deleting scheduled email': 'Fehler beim Löschen der geplanten E-Mail',
    'Failed to delete scheduled email': 'Löschen der geplanten E-Mail fehlgeschlagen',
    'Label (optional)': 'Label (optional)',
    'Manage your email schedule': 'Verwalte deinen E-Mail-Zeitplan',
    New: 'Neu',
    'No Scheduled Emails': 'Keine geplanten E-Mails',
    'Save to master list': 'In die Masterliste speichern',
    'Schedule Summary': 'Zeitplanübersicht',
    'Scheduled Date': 'Geplantes Datum',
    'Scheduled email deleted successfully': 'Geplante E-Mail erfolgreich gelöscht',
    'Select Students': 'Schüler auswählen',
    'Select Teachers': 'Lehrer auswählen',
    'Send emails to users based on timezone': 'E-Mails an Benutzer basierend auf der Zeitzone senden',
    Sent: 'Gesendet',
    'Set date': 'Datum festlegen',
    'Set label (for internal use)': 'Label festlegen (für interne Verwendung)',
    'Set time': 'Uhrzeit festlegen',
    'Target Group': 'Zielgruppe',
    'View scheduled emails': 'Geplante E-Mails anzeigen',
    at: 'um',
    'Responding to': 'Antwort auf',
    'Need a template?': 'Brauchen Sie eine Vorlage?',
    'Confirm Password': 'Passwort bestätigen',
    'Re-enter your new password': 'Neues Passwort erneut eingeben',
    'Show all': 'Alle anzeigen',

    'Select Recipients': 'Empfänger auswählen',
    'Select individual students or create a group to share this content with': 'Wählen Sie einzelne Schüler aus oder erstellen Sie eine Gruppe, um diesen Inhalt zu teilen',
    'Select specific year groups to share this content with': 'Wählen Sie bestimmte Jahrgangsstufen aus, um diesen Inhalt zu teilen',
    'Select specific classes to share this content with': 'Wählen Sie bestimmte Klassen aus, um diesen Inhalt zu teilen',
    'Select staff members to share this content with': 'Wählen Sie Mitarbeiter aus, um diesen Inhalt zu teilen',

    'Do you want to pause the program?': 'Möchtest du das Programm pausieren?',
    'Resume program': 'Programm fortsetzen',
    'Stop program': 'Programm stoppen',
    'Share your thoughts here': 'Teile deine Gedanken hier...',
    'This tool lets you manage your active programs': 'Dieses Tool ermöglicht es Ihnen, Ihre aktiven Programme zu verwalten',
    stopProgram: 'Programm stoppen',
    'Refresher Videos': 'Aktualisierte Videos',
    'Selecting role is required': 'Die Auswahl einer Rolle ist erforderlich',
    'Generate login QR code': 'Login-QR-Code generieren',
    'Show QR code': 'QR-Code anzeigen',
    'Hide QR code': 'QR-Code ausblenden',
    'Hide login QR code': 'Login-QR-Code ausblenden',
    'custom average': '{{customLabel}} Durchschnitt',
    'Comparison target': 'Vergleichsziel',
    'Select class or year you want to compare your class to': 'Wählen Sie die Klasse oder den Jahrgang aus, mit dem Sie Ihre Klasse vergleichen möchten',
    'Content is not deleted': 'Der Inhalt wurde nicht gelöscht',
    'Average number of responses daily': 'Durchschnittliche Anzahl der täglichen Antworten',
    'This content is visible to the following groups:': 'Dieser Inhalt ist für die folgenden Gruppen sichtbar:',
    'Target preview': 'Zielvorschau',
    'Number of teachers who answered "How are you today?" on this date': 'Anzahl der Lehrer, die am diesem Datum "Wie geht es dir heute?" beantwortet haben',
    listOfUsersWhoHaventLoggedInYet: 'Liste der Benutzer, die sich noch nicht angemeldet haben',
    pulseCheck: 'Stimmungscheck',
    viewAs: 'Ansehen als',
    Overall: 'Gesamt',
    Emotional: 'Emotionales Wohlbefinden',

    'Students feeling good': 'Schüler fühlen sich gut',

    Support: 'Unterstützung',

    'Students felt supported': 'Schüler fühlten sich unterstützt',

    Coping: 'Bewältigung',

    'Students coping well': 'Schüler kommen gut zurecht',

    Sleep: 'Schlaf',

    'Students sleeping well': 'Schüler schlafen gut',
    'vs last week': 'vs letzte Woche',
    'Trends Over Time': 'Trends im Laufe der Zeit',
    'Average response (1–5) by week': 'Durchschnittliche Antwort (1–5) nach Woche',
    'Latest vs Last Week': 'Aktuell vs letzte Woche',
    'Direction of change': 'Richtung der Veränderung',
    Decline: 'Abnahme',
    Improvement: 'Verbesserung',
    'School Overview': 'Schulübersicht',

    'Class Overview': 'Klassenübersicht',

    'Heatmap of year-group averages': 'Heatmap der Durchschnittswerte nach Jahrgang',

    'Heatmap of student responses': 'Heatmap der Schülerantworten',

    'Avg 1–5 per pulse run': 'Durchschnitt 1–5 pro Pulse-Check',
    'Very High': 'Sehr hoch',

    High: 'Hoch',

    Moderate: 'Mittel',

    Low: 'Niedrig',

    'Very Low': 'Sehr niedrig',
    'Needs Attention': 'Benötigt Aufmerksamkeit',

    'Students with low or declining pulse': 'Schüler mit niedrigem oder sinkendem Puls',

    'At risk': 'Gefährdet',

    Declining: 'Abnehmend',

    Watch: 'Beobachten',

    'vs start': 'im Vergleich zum Start',

    'View profile': 'Profil ansehen',

    'Open student list': 'Schülerliste öffnen',
    "Data is anonymised when viewed at group level and follows your school's privacy settings.":
        'Daten werden auf Gruppenebene anonymisiert und entsprechen den Datenschutzeinstellungen Ihrer Schule.',
    'Student list': 'Schülerliste',

    All: 'Alle',

    'At risk': 'Gefährdet',

    Declining: 'Abnehmend',

    Watch: 'Beobachten',

    Stable: 'Stabil',

    'Lowest score first': 'Niedrigste Bewertung zuerst',

    'Biggest decline first': 'Größter Rückgang zuerst',

    'Name A→Z': 'Name A→Z',

    'Highest score first': 'Höchste Bewertung zuerst',

    Target: 'Ziel',

    'All students': 'Alle Schüler',

    'Pulse Check (last 8 weeks)': 'Pulse Check (letzte 8 Wochen)',

    selected: 'ausgewählt',

    'header actions apply to selection': 'Header-Aktionen gelten für Auswahl',

    Clear: 'Leeren',

    'No students match this filter.': 'Keine Schüler passen zu diesem Filter.',
    "Everyone's engaged 🎉": 'Alle sind aktiv 🎉',
    'Adjust inactivity settings': 'Inaktivitätseinstellungen anpassen',
    "School holidays in this period don't count toward inactivity.": 'Schulferien in diesem Zeitraum zählen nicht zur Inaktivität.',
    "{{n}} students who have never engaged aren't shown — your inactivity settings exclude them.":
        '{{n}} Schüler, die noch nie aktiv waren, werden nicht angezeigt — deine Inaktivitätseinstellungen schließen sie aus.',
    'No classes assigned to you': 'Dir sind keine Klassen zugewiesen',
    "Inactivity only covers students in the classes or years you're responsible for. Once your school admin assigns you some, they'll show up here.":
        'Inaktivität umfasst nur Schüler in den Klassen oder Jahrgängen, für die du zuständig bist. Sobald deine Schuladministration dir welche zuweist, erscheinen sie hier.',
    'No students yet': 'Noch keine Schüler',
    'There are no student accounts in your classes yet. Once students are added, anyone who goes quiet will show up here.':
        'In deinen Klassen gibt es noch keine Schülerkonten. Sobald Schüler hinzugefügt werden, erscheint hier jeder, der inaktiv wird.',
    'No one has engaged yet': 'Noch niemand war aktiv',
    "{{n}} students joined in the past {{days}} days and haven't checked in or responded yet. Students only count as inactive after {{days}} quiet days, so they'll appear here if they stay quiet.":
        '{{n}} Schüler sind in den letzten {{days}} Tagen dazugekommen und haben noch keinen Check-in gemacht oder geantwortet. Schüler gelten erst nach {{days}} Tagen ohne Aktivität als inaktiv — bleiben sie still, erscheinen sie hier.',
    'No recently lapsed students': 'Keine kürzlich inaktiven Schüler',
    '{{engaged}} of {{total}} students checked in or responded in the past {{days}} days.':
        '{{engaged}} von {{total}} Schülern haben in den letzten {{days}} Tagen einen Check-in gemacht oder geantwortet.',
    '{{engaged}} of {{total}} students active': '{{engaged}} von {{total}} Schülern aktiv',
    "{{n}} new students haven't engaged yet": '{{n}} neue Schüler waren noch nicht aktiv',
    "Couldn't load inactivity data": 'Inaktivitätsdaten konnten nicht geladen werden',
    'Something went wrong while checking student engagement. Please try again.': 'Beim Prüfen der Schüleraktivität ist etwas schiefgelaufen. Bitte versuche es erneut.',
    'Try again': 'Erneut versuchen',
    'No student has gone {{days}} days without logging an emotion or responding to a check-in. Nothing needs your attention at this threshold.':
        'Kein Schüler war {{days}} Tage lang ohne Emotion oder Antwort auf einen Check-in. Bei diesem Schwellenwert ist nichts zu tun.',
    '1 student quiet for {{days}}+ days': '1 Schüler seit {{days}}+ Tagen inaktiv',
    '{{n}} students quiet for {{days}}+ days': '{{n}} Schüler seit {{days}}+ Tagen inaktiv',
    'No one quiet for {{days}}+ days': 'Niemand seit {{days}}+ Tagen inaktiv',

    '3-week avg': '3-Wochen-Durchschnitt',
    'Assign action': 'Aktion zuweisen',

    'Export CSV': 'CSV exportieren',

    'Flag selection': 'Auswahl markieren',
    Showing: 'Anzeigen',
    'No targets found': 'Keine Ziele gefunden',

    chatStatsButton: 'Statistik',
    chatStatsTitle: 'Chat-Aktivität der Schüler',
    chatStatsSubtitle: 'Von Schülern begonnene Chats · Kontaktaufnahme und Hilfesuche',
    chatStatsLoading: 'Wird geladen…',
    chatStatsError: 'Chat-Statistik konnte nicht geladen werden',
    chatStatsRange7Days: '7 Tage',
    chatStatsRange30Days: '30 Tage',
    chatStatsRangeThisYear: 'Dieses Jahr',
    chatStatsRangeCustom: 'Benutzerdefiniert',
    chatStatsAllClasses: 'Alle Klassen',
    chatStatsTypeLabel: 'Typ:',
    chatStatsTypeTeacher: 'Lehrkraft',
    chatStatsTypeCounsellor: 'Beratung',
    chatStatsTypeSos: 'SOS',
    chatStatsClassOption: 'Jahrgang {{year}} · {{name}}',
    chatStatsSection1: 'Wie stark wird der Chat genutzt?',
    chatStatsStudentsInitiated: 'Schüler, die Chats begonnen haben',
    chatStatsOfStudents: 'von {{total}} · {{percent}}',
    chatStatsTotalChats: 'Begonnene Chats insgesamt',
    chatStatsVsPrevious: 'gegenüber {{count}} im Vorzeitraum',
    chatStatsAvgPerStudent: 'Chats pro Schüler (Ø)',
    chatStatsChatsEach: 'Chats pro Person',
    chatStatsPerDay: '{{count}} begonnene Chats pro Tag',
    chatStatsByType: 'Chats nach Typ',
    chatStatsDaysBadge: '{{count}} Tage',
    chatStatsInsightMoreChats: 'mehr begonnene Chats als im Vorzeitraum – Schüler wenden sich offenbar eher an jemanden.',
    chatStatsInsightFewerChats: 'weniger begonnene Chats als im Vorzeitraum – prüfen Sie, wie sichtbar der Chat für Schüler ist.',
    chatStatsInsightMoreSos: 'mehr SOS-Chats als im Vorzeitraum. Das kann wachsendes Vertrauen bedeuten oder mehr Schüler in Not.',
    chatStatsInsightFewerSos: 'weniger SOS-Chats als im Vorzeitraum.',
    chatStatsSection2: 'Antwortet die Schule schnell genug?',
    chatStatsResponsiveness: 'Reaktionszeit',
    chatStatsWithin24h: 'der Chats wurden innerhalb von 24 Stunden beantwortet',
    chatStatsAvgFirstResponse: 'Durchschnittliche erste Antwort',
    chatStatsAvgSosResponse: 'Durchschnittliche SOS-Antwort',
    chatStatsWasLastPeriod: 'im Vorzeitraum {{value}}',
    chatStatsNoPreviousPeriod: 'kein Vorzeitraum',
    chatStatsPriorityTier: 'Priorität',
    chatStatsAnsweredLate: '{{count}} wurden nach mehr als 7 Tagen beantwortet und fließen nicht in die Durchschnitte ein.',
    chatStatsSection3: 'Was braucht jetzt Aufmerksamkeit?',
    chatStatsNeedsAttention: 'Braucht jetzt Aufmerksamkeit',
    chatStatsAwaiting: 'Warten auf erste Antwort',
    chatStatsOverdue: 'Überfällig > 24 Stunden',
    chatStatsStaffOutstanding: 'Mitarbeitende mit offenen Chats',
    chatStatsNothingWaiting: 'Es wartet nichts auf eine Antwort.',
    chatStatsOverdueBadge: '{{count}} überfällig',
    chatStatsUnknownUser: 'Unbekannter Nutzer',
    chatStatsByClass: 'Chats nach Klasse / Jahrgang',
    chatStatsNoClassInfo: 'Keine Klassenangaben für die Chats in diesem Zeitraum.',
    chatStatsUnnamedClass: 'Unbenannte Klasse',
    chatStatsEmptyTitle: 'In diesem Zeitraum wurden keine Chats begonnen',
    chatStatsEmptyBody:
        'Kein Schüler hat im gewählten Zeitraum einen Lehrkraft-, Beratungs- oder SOS-Chat begonnen. Erweitern Sie den Zeitraum oder prüfen Sie, ob der Chat für diese Klassen aktiviert ist.',
    chatStatsSearchClasses: 'Klassen suchen…',
    chatStatsNoMatchingClasses: 'Keine passenden Klassen',
    pinnedPosts: 'Angeheftete Beiträge', pinned: 'Angeheftet', pinPost: 'Beitrag anheften', unpin: 'Lösen',
    pinnedBy: 'Angeheftet von', pinnedOn: 'Angeheftet am', pinnedPostsOverviewHelp: 'Angeheftete Beiträge für Ihre Schüler. Nur Administratoren können sie verwalten.',
    noPinnedPosts: 'Es gibt keine angehefteten Beiträge.', unavailablePinnedPost: 'Nicht verfügbarer angehefteter Beitrag', postUnavailable: 'Beitrag nicht verfügbar',
    postPinned: 'Beitrag angeheftet', postUnpinned: 'Beitrag gelöst', pinnedPostDeleteRestricted: 'Angeheftete Beiträge müssen von einem Administrator gelöst werden, bevor sie gelöscht werden können.', pinPostFailed: 'Der Beitrag konnte nicht angeheftet werden', unpinPostFailed: 'Der Beitrag konnte nicht gelöst werden',
    confirmUnpinPost: 'Diesen Beitrag lösen?', confirmPinPost: 'Diesen Beitrag anheften?', manyPinnedPostsWarning: '{{count}} Schüler hätten {{total}} aktive angeheftete Beiträge. Trotzdem anheften?', recipients: 'Empfänger',
    pinPostConfirmationHelp: 'Dieser Beitrag erscheint im angehefteten Bereich aller Schüler seiner aktuellen Zielgruppe.', unpinPostConfirmationHelp: 'Der Beitrag wird nicht mehr im angehefteten Bereich angezeigt. Im normalen Feed bleibt er erhalten.', highVolumePinConfirmationHelp: 'Diese Zielgruppe hat bereits mehrere aktive angeheftete Beiträge. Bitte bestätigen Sie, dass dieser Beitrag wichtig genug ist.',
    orSignInWith: 'oder weiter mit',
    signInWithMicrosoft: 'Microsoft',
    signInWithGoogle: 'Google',
    ssoSigningIn: 'Sie werden angemeldet...',
    ssoErrorNotEnabled: 'Die Anmeldung mit einem Schulkonto ist für Ihre Schule nicht aktiviert. Bitte melden Sie sich mit E-Mail und Passwort an.',
    ssoErrorAccountNotFound: 'Für dieses Schulkonto wurde kein Upstrive-Konto gefunden. Bitte wenden Sie sich an die Administration Ihrer Schule.',
    ssoErrorDuplicateAccounts: 'Es gibt zwei Konten mit dieser E-Mail-Adresse. Bitte wenden Sie sich an die Administration Ihrer Schule.',
    ssoErrorPersonalAccount: 'Bitte verwenden Sie Ihr Schulkonto, kein privates Konto.',
    ssoErrorUserDisabled: 'Ihr Konto ist deaktiviert. Bitte wenden Sie sich an die Administration Ihrer Schule.',
    ssoErrorTenantMismatch: 'Dieses Schulkonto stimmt nicht mit dem für Ihre Schule hinterlegten Konto überein. Bitte wenden Sie sich an die Administration Ihrer Schule.',
    ssoErrorUnverifiedEmail: 'Ihr Schulkonto konnte noch nicht verifiziert werden. Bitte wenden Sie sich an die Administration Ihrer Schule.',
    ssoErrorItAccessWebOnly: 'Dieses Konto kann sich nur auf der Upstrive-Education-Website anmelden, nicht in dieser App.',
    ssoErrorCancelled: 'Die Anmeldung wurde abgebrochen.',
    ssoErrorGeneric: 'Die Anmeldung mit Ihrem Schulkonto ist fehlgeschlagen. Bitte versuchen Sie es erneut.',
    // Seitenleisten-Navigation
    mainNavigation: 'Hauptnavigation',
    collapseSidebar: 'Seitenleiste einklappen',
    expandSidebar: 'Seitenleiste ausklappen',
    'Upstrive Early': 'Upstrive Early',
    'Tap a student to change their emotion': 'Tippe auf ein Kind, um seine Emotion zu ändern',
    'Why do you feel this way? (optional)': 'Warum fühlst du dich so? (optional)',
    'Could not save the emotion. Please try again.': 'Die Emotion konnte nicht gespeichert werden. Bitte versuche es erneut.',
    managementLoginBasisNote: 'Ohne Upstrive Early Schüler:innen, die sich nicht einzeln anmelden',
    managementLoggedInTooltip: '{{n}} von {{total}} haben sich mindestens einmal angemeldet',
    managementNotLoggedInTooltip: '{{n}} von {{total}} haben sich noch nie angemeldet',
    managementPrimaryTooltip: '{{n}} Upstrive Early Schüler:innen. Sie melden sich an einem gemeinsamen Klassengerät an und haben daher keinen eigenen Login.',

    // Fehlergrenze / Wiederherstellung nach einem fehlgeschlagenen Laden
    errorBoundaryTitle: 'Etwas ist schiefgelaufen',
    errorBoundaryMessage: 'Diese Seite konnte nicht geladen werden. Ein Neuladen behebt das Problem meistens.',
    errorBoundaryOutdatedMessage: 'Es wurde eine neuere Version von Upstrive veröffentlicht. Laden Sie die Seite neu, um fortzufahren.',
    errorBoundaryReload: 'Seite neu laden',
    imageCouldNotBeLoaded: 'Dieses Bild konnte nicht geladen werden.',
    connectionOffline: 'Sie sind offline. Manches funktioniert erst wieder, wenn Ihre Verbindung zurück ist.',
    connectionRestored: 'Sie sind wieder online.',
    archiveSearchPlaceholder: 'Archiv durchsuchen',
    archiveSearchClear: 'Suche löschen',
    archiveFiltersLabel: 'Archiv filtern',
    archiveFilterAll: 'Alle',
    archiveFilterMoods: 'Stimmungen',
    archiveFilterPolls: 'Abstimmungen',
    archiveFilterQuestions: 'Fragen',
    archiveFilterSurveys: 'Umfragen',
    archiveFilterJournals: 'Tagebücher',
    archiveKindJournal: 'Tagebuch',
    archiveMoodTitle: 'Wie geht es dir?',
    archiveReasons: 'Gründe',
    archiveYourAnswer: 'Deine Antwort',
    archiveYourAnswers: 'Deine Antworten',
    archiveAnswer: 'Antwort',
    archiveAnswers: 'Antworten',
    archiveSelected: 'ausgewählt',
    archiveNotAnswered: 'Nicht beantwortet',
    archiveSurveyProgress: '{{answered}} von {{total}} beantwortet',
    archiveJournalProgress: '{{answered}} von {{total}} Tagen erledigt',
    archiveViewSurvey: 'Alle {{count}} Antworten ansehen',
    archiveOpenJournal: 'Tagebuch öffnen',
    archiveCompletedOn: 'Erledigt am',
    archiveJournalWrittenOn: 'Geschrieben am',
    archiveJournalPrivateNote: 'Tagebuchantworten sind privat',
    archiveJournalPrivacy: 'Dein Tagebuch ist nur für dich – niemand kann lesen, was du schreibst.',
    archiveJournalStaffPrivacy: 'Tagebücher sind privat. Du siehst, an welchen Tagen geschrieben wurde, aber nicht was.',
    archiveEmptyTitle: 'Dein Archiv ist noch leer',
    archiveEmptyFilteredTitle: 'Hier ist noch nichts',
    archiveEmptyAll: 'Jeder Check-in, jede Abstimmung, Frage, Umfrage und jeder Tagebucheintrag, den du abschließt, wird hier aufbewahrt.',
    archiveEmptyMood: 'Deine Stimmungs-Check-ins erscheinen hier.',
    archiveEmptyPoll: 'Abstimmungen, die du beantwortest, erscheinen hier.',
    archiveEmptyQuestion: 'Fragen, die du beantwortest, erscheinen hier.',
    archiveEmptySurvey: 'Umfragen, die du abschließt, erscheinen hier.',
    archiveEmptyJournal: 'Deine Tagebucheinträge erscheinen hier.',
    archiveStaffEmptyTitle: 'Noch keine Aktivität',
    archiveStaffEmptyAll: 'Sobald diese:r Schüler:in Check-ins, Abstimmungen, Fragen, Umfragen oder Tagebücher beantwortet, erscheinen sie hier.',
    archiveStaffEmptyFiltered: 'In dieser Kategorie gibt es noch nichts.',
    archiveGoToTasks: 'Zu deinen Aufgaben',
    archiveNoResultsTitle: 'Keine Ergebnisse für „{{query}}“',
    archiveNoResultsMessage: 'Versuche ein anderes Wort oder suche nach etwas aus den Antworten.',
    archiveErrorTitle: 'Wir konnten das Archiv nicht laden',
    archiveErrorMessage: 'Prüfe deine Verbindung und versuche es erneut.',
    archiveTryAgain: 'Nochmal versuchen',
    archiveLoadMoreError: 'Mehr konnte nicht geladen werden.',
    archiveEnd: 'Das ist bisher alles',
}
export default TRANSLATION_DE
